/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  DateTime: any;
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  Dimension: any;
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  HexColor: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  Quality: any;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  contentType?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
  transform?: InputMaybe<ImageTransformOptions>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']>;
  contentType_contains?: InputMaybe<Scalars['String']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentType_not?: InputMaybe<Scalars['String']>;
  contentType_not_contains?: InputMaybe<Scalars['String']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName?: InputMaybe<Scalars['String']>;
  fileName_contains?: InputMaybe<Scalars['String']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName_not?: InputMaybe<Scalars['String']>;
  fileName_not_contains?: InputMaybe<Scalars['String']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  height?: InputMaybe<Scalars['Int']>;
  height_exists?: InputMaybe<Scalars['Boolean']>;
  height_gt?: InputMaybe<Scalars['Int']>;
  height_gte?: InputMaybe<Scalars['Int']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  height_lt?: InputMaybe<Scalars['Int']>;
  height_lte?: InputMaybe<Scalars['Int']>;
  height_not?: InputMaybe<Scalars['Int']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Int']>;
  size_exists?: InputMaybe<Scalars['Boolean']>;
  size_gt?: InputMaybe<Scalars['Int']>;
  size_gte?: InputMaybe<Scalars['Int']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size_lt?: InputMaybe<Scalars['Int']>;
  size_lte?: InputMaybe<Scalars['Int']>;
  size_not?: InputMaybe<Scalars['Int']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  url_contains?: InputMaybe<Scalars['String']>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_not?: InputMaybe<Scalars['String']>;
  url_not_contains?: InputMaybe<Scalars['String']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  width?: InputMaybe<Scalars['Int']>;
  width_exists?: InputMaybe<Scalars['Boolean']>;
  width_gt?: InputMaybe<Scalars['Int']>;
  width_gte?: InputMaybe<Scalars['Int']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  width_lt?: InputMaybe<Scalars['Int']>;
  width_lte?: InputMaybe<Scalars['Int']>;
  width_not?: InputMaybe<Scalars['Int']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  contentTypeAssetCollection?: Maybe<ContentTypeAssetCollection>;
  entryCollection?: Maybe<EntryCollection>;
  newsCollection?: Maybe<NewsCollection>;
};


export type AssetLinkingCollectionsContentTypeAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type Card = Entry & {
  __typename?: 'Card';
  assetsCollection?: Maybe<CardAssetsCollection>;
  backgroundAsset?: Maybe<ContentTypeAsset>;
  cardAspectRatio?: Maybe<Scalars['String']>;
  cardLayout?: Maybe<Scalars['String']>;
  contentLayout?: Maybe<Scalars['String']>;
  contentSize?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  ctaCollection?: Maybe<CardCtaCollection>;
  link?: Maybe<Entry>;
  linkedFrom?: Maybe<CardLinkingCollections>;
  margins?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  sys: Sys;
  text?: Maybe<Text>;
  type?: Maybe<Scalars['String']>;
  widthLimit?: Maybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardAssetsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CardAssetsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentTypeAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardBackgroundAssetArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ContentTypeAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardCardAspectRatioArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardCardLayoutArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardContentLayoutArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardContentSizeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CardCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardMarginsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/card) */
export type CardWidthLimitArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CardAssetsCollection = {
  __typename?: 'CardAssetsCollection';
  items: Array<Maybe<ContentTypeAsset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum CardAssetsCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  ControlsAsc = 'controls_ASC',
  ControlsDesc = 'controls_DESC',
  ImageUrlAsc = 'imageUrl_ASC',
  ImageUrlDesc = 'imageUrl_DESC',
  LoopAsc = 'loop_ASC',
  LoopDesc = 'loop_DESC',
  MutedAsc = 'muted_ASC',
  MutedDesc = 'muted_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VideoResolutionAsc = 'videoResolution_ASC',
  VideoResolutionDesc = 'videoResolution_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type CardCollection = {
  __typename?: 'CardCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CardCtaCollection = {
  __typename?: 'CardCtaCollection';
  items: Array<Maybe<Cta>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum CardCtaCollectionOrder {
  IconPositionAsc = 'iconPosition_ASC',
  IconPositionDesc = 'iconPosition_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  NewTabAsc = 'newTab_ASC',
  NewTabDesc = 'newTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemplateAsc = 'template_ASC',
  TemplateDesc = 'template_DESC'
}

export type CardFilter = {
  AND?: InputMaybe<Array<InputMaybe<CardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CardFilter>>>;
  assets?: InputMaybe<CfContentTypeAssetNestedFilter>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  backgroundAsset?: InputMaybe<CfContentTypeAssetNestedFilter>;
  backgroundAsset_exists?: InputMaybe<Scalars['Boolean']>;
  cardAspectRatio?: InputMaybe<Scalars['String']>;
  cardAspectRatio_contains?: InputMaybe<Scalars['String']>;
  cardAspectRatio_exists?: InputMaybe<Scalars['Boolean']>;
  cardAspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cardAspectRatio_not?: InputMaybe<Scalars['String']>;
  cardAspectRatio_not_contains?: InputMaybe<Scalars['String']>;
  cardAspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cardLayout?: InputMaybe<Scalars['String']>;
  cardLayout_contains?: InputMaybe<Scalars['String']>;
  cardLayout_exists?: InputMaybe<Scalars['Boolean']>;
  cardLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cardLayout_not?: InputMaybe<Scalars['String']>;
  cardLayout_not_contains?: InputMaybe<Scalars['String']>;
  cardLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentLayout?: InputMaybe<Scalars['String']>;
  contentLayout_contains?: InputMaybe<Scalars['String']>;
  contentLayout_exists?: InputMaybe<Scalars['Boolean']>;
  contentLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentLayout_not?: InputMaybe<Scalars['String']>;
  contentLayout_not_contains?: InputMaybe<Scalars['String']>;
  contentLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentSize?: InputMaybe<Scalars['String']>;
  contentSize_contains?: InputMaybe<Scalars['String']>;
  contentSize_exists?: InputMaybe<Scalars['Boolean']>;
  contentSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentSize_not?: InputMaybe<Scalars['String']>;
  contentSize_not_contains?: InputMaybe<Scalars['String']>;
  contentSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  ctaCollection_exists?: InputMaybe<Scalars['Boolean']>;
  link_exists?: InputMaybe<Scalars['Boolean']>;
  margins?: InputMaybe<Scalars['Boolean']>;
  margins_exists?: InputMaybe<Scalars['Boolean']>;
  margins_not?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfTextNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  widthLimit?: InputMaybe<Scalars['Boolean']>;
  widthLimit_exists?: InputMaybe<Scalars['Boolean']>;
  widthLimit_not?: InputMaybe<Scalars['Boolean']>;
};

export type CardLinkingCollections = {
  __typename?: 'CardLinkingCollections';
  carouselCollection?: Maybe<CarouselCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
  sectionCollection?: Maybe<SectionCollection>;
};


export type CardLinkingCollectionsCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CardLinkingCollectionsCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CardLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CardLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CardLinkingCollectionsSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CardLinkingCollectionsSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CardLinkingCollectionsCarouselCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SpeedAsc = 'speed_ASC',
  SpeedDesc = 'speed_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CardLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CardLinkingCollectionsSectionCollectionOrder {
  ColumnsAsc = 'columns_ASC',
  ColumnsDesc = 'columns_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CardOrder {
  CardAspectRatioAsc = 'cardAspectRatio_ASC',
  CardAspectRatioDesc = 'cardAspectRatio_DESC',
  CardLayoutAsc = 'cardLayout_ASC',
  CardLayoutDesc = 'cardLayout_DESC',
  ContentLayoutAsc = 'contentLayout_ASC',
  ContentLayoutDesc = 'contentLayout_DESC',
  ContentSizeAsc = 'contentSize_ASC',
  ContentSizeDesc = 'contentSize_DESC',
  MarginsAsc = 'margins_ASC',
  MarginsDesc = 'margins_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  WidthLimitAsc = 'widthLimit_ASC',
  WidthLimitDesc = 'widthLimit_DESC'
}

/** Structural Component - Display content in a carousel [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/carousel) */
export type Carousel = Entry & {
  __typename?: 'Carousel';
  autoplay?: Maybe<Array<Maybe<Scalars['String']>>>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<CarouselLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  slidesCollection?: Maybe<CarouselSlidesCollection>;
  speed?: Maybe<Scalars['Int']>;
  sys: Sys;
  text?: Maybe<Text>;
};


/** Structural Component - Display content in a carousel [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/carousel) */
export type CarouselAutoplayArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural Component - Display content in a carousel [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/carousel) */
export type CarouselLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Structural Component - Display content in a carousel [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/carousel) */
export type CarouselNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural Component - Display content in a carousel [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/carousel) */
export type CarouselSlidesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CarouselSlidesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CardFilter>;
};


/** Structural Component - Display content in a carousel [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/carousel) */
export type CarouselSpeedArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural Component - Display content in a carousel [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/carousel) */
export type CarouselTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TextFilter>;
};

export type CarouselCollection = {
  __typename?: 'CarouselCollection';
  items: Array<Maybe<Carousel>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CarouselFilter = {
  AND?: InputMaybe<Array<InputMaybe<CarouselFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CarouselFilter>>>;
  autoplay_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoplay_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoplay_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoplay_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slides?: InputMaybe<CfCardNestedFilter>;
  slidesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  speed?: InputMaybe<Scalars['Int']>;
  speed_exists?: InputMaybe<Scalars['Boolean']>;
  speed_gt?: InputMaybe<Scalars['Int']>;
  speed_gte?: InputMaybe<Scalars['Int']>;
  speed_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  speed_lt?: InputMaybe<Scalars['Int']>;
  speed_lte?: InputMaybe<Scalars['Int']>;
  speed_not?: InputMaybe<Scalars['Int']>;
  speed_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfTextNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
};

export type CarouselLinkingCollections = {
  __typename?: 'CarouselLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type CarouselLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CarouselLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CarouselLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CarouselLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CarouselOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SpeedAsc = 'speed_ASC',
  SpeedDesc = 'speed_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CarouselSlidesCollection = {
  __typename?: 'CarouselSlidesCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum CarouselSlidesCollectionOrder {
  CardAspectRatioAsc = 'cardAspectRatio_ASC',
  CardAspectRatioDesc = 'cardAspectRatio_DESC',
  CardLayoutAsc = 'cardLayout_ASC',
  CardLayoutDesc = 'cardLayout_DESC',
  ContentLayoutAsc = 'contentLayout_ASC',
  ContentLayoutDesc = 'contentLayout_DESC',
  ContentSizeAsc = 'contentSize_ASC',
  ContentSizeDesc = 'contentSize_DESC',
  MarginsAsc = 'margins_ASC',
  MarginsDesc = 'margins_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  WidthLimitAsc = 'widthLimit_ASC',
  WidthLimitDesc = 'widthLimit_DESC'
}

/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAsset = Entry & {
  __typename?: 'ContentTypeAsset';
  animationData?: Maybe<Scalars['JSON']>;
  autoplay?: Maybe<Scalars['Boolean']>;
  contentfulMetadata: ContentfulMetadata;
  context?: Maybe<Array<Maybe<Scalars['String']>>>;
  controls?: Maybe<Scalars['Boolean']>;
  image?: Maybe<Asset>;
  imageUrl?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ContentTypeAssetLinkingCollections>;
  loop?: Maybe<Scalars['Boolean']>;
  muted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  sizes?: Maybe<Array<Maybe<Scalars['String']>>>;
  sys: Sys;
  video?: Maybe<Asset>;
  videoResolution?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetAnimationDataArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetAutoplayArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetContextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetControlsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetImageUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetLoopArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetMutedArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetSizesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetVideoArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetVideoResolutionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for media references [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/asset) */
export type ContentTypeAssetVideoUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ContentTypeAssetCollection = {
  __typename?: 'ContentTypeAssetCollection';
  items: Array<Maybe<ContentTypeAsset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ContentTypeAssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentTypeAssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentTypeAssetFilter>>>;
  animationData_exists?: InputMaybe<Scalars['Boolean']>;
  autoplay?: InputMaybe<Scalars['Boolean']>;
  autoplay_exists?: InputMaybe<Scalars['Boolean']>;
  autoplay_not?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  context_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  context_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  context_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  context_exists?: InputMaybe<Scalars['Boolean']>;
  controls?: InputMaybe<Scalars['Boolean']>;
  controls_exists?: InputMaybe<Scalars['Boolean']>;
  controls_not?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  imageUrl_contains?: InputMaybe<Scalars['String']>;
  imageUrl_exists?: InputMaybe<Scalars['Boolean']>;
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageUrl_not?: InputMaybe<Scalars['String']>;
  imageUrl_not_contains?: InputMaybe<Scalars['String']>;
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  loop?: InputMaybe<Scalars['Boolean']>;
  loop_exists?: InputMaybe<Scalars['Boolean']>;
  loop_not?: InputMaybe<Scalars['Boolean']>;
  muted?: InputMaybe<Scalars['Boolean']>;
  muted_exists?: InputMaybe<Scalars['Boolean']>;
  muted_not?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sizes_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sizes_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sizes_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sizes_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  videoResolution?: InputMaybe<Scalars['String']>;
  videoResolution_contains?: InputMaybe<Scalars['String']>;
  videoResolution_exists?: InputMaybe<Scalars['Boolean']>;
  videoResolution_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoResolution_not?: InputMaybe<Scalars['String']>;
  videoResolution_not_contains?: InputMaybe<Scalars['String']>;
  videoResolution_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoUrl?: InputMaybe<Scalars['String']>;
  videoUrl_contains?: InputMaybe<Scalars['String']>;
  videoUrl_exists?: InputMaybe<Scalars['Boolean']>;
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoUrl_not?: InputMaybe<Scalars['String']>;
  videoUrl_not_contains?: InputMaybe<Scalars['String']>;
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  video_exists?: InputMaybe<Scalars['Boolean']>;
};

export type ContentTypeAssetLinkingCollections = {
  __typename?: 'ContentTypeAssetLinkingCollections';
  cardCollection?: Maybe<CardCollection>;
  entryCollection?: Maybe<EntryCollection>;
  galleryItemCollection?: Maybe<GalleryItemCollection>;
  heroSlideCollection?: Maybe<HeroSlideCollection>;
  mediaCollection?: Maybe<MediaCollection>;
  metaDataCollection?: Maybe<MetaDataCollection>;
  newsCollection?: Maybe<NewsCollection>;
  videoCollection?: Maybe<VideoCollection>;
};


export type ContentTypeAssetLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeAssetLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContentTypeAssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContentTypeAssetLinkingCollectionsGalleryItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeAssetLinkingCollectionsGalleryItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContentTypeAssetLinkingCollectionsHeroSlideCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeAssetLinkingCollectionsHeroSlideCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContentTypeAssetLinkingCollectionsMediaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeAssetLinkingCollectionsMediaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContentTypeAssetLinkingCollectionsMetaDataCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeAssetLinkingCollectionsMetaDataCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContentTypeAssetLinkingCollectionsNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeAssetLinkingCollectionsNewsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ContentTypeAssetLinkingCollectionsVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeAssetLinkingCollectionsVideoCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ContentTypeAssetLinkingCollectionsCardCollectionOrder {
  CardAspectRatioAsc = 'cardAspectRatio_ASC',
  CardAspectRatioDesc = 'cardAspectRatio_DESC',
  CardLayoutAsc = 'cardLayout_ASC',
  CardLayoutDesc = 'cardLayout_DESC',
  ContentLayoutAsc = 'contentLayout_ASC',
  ContentLayoutDesc = 'contentLayout_DESC',
  ContentSizeAsc = 'contentSize_ASC',
  ContentSizeDesc = 'contentSize_DESC',
  MarginsAsc = 'margins_ASC',
  MarginsDesc = 'margins_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  WidthLimitAsc = 'widthLimit_ASC',
  WidthLimitDesc = 'widthLimit_DESC'
}

export enum ContentTypeAssetLinkingCollectionsGalleryItemCollectionOrder {
  ItemTypeAsc = 'itemType_ASC',
  ItemTypeDesc = 'itemType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentTypeAssetLinkingCollectionsHeroSlideCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OverlayAssetAsc = 'overlayAsset_ASC',
  OverlayAssetDesc = 'overlayAsset_DESC',
  OverlayCtaLabelAsc = 'overlayCtaLabel_ASC',
  OverlayCtaLabelDesc = 'overlayCtaLabel_DESC',
  SlideAppearanceAsc = 'slideAppearance_ASC',
  SlideAppearanceDesc = 'slideAppearance_DESC',
  SlideTypeAsc = 'slideType_ASC',
  SlideTypeDesc = 'slideType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentTypeAssetLinkingCollectionsMediaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ContentTypeAssetLinkingCollectionsMetaDataCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContentTypeAssetLinkingCollectionsNewsCollectionOrder {
  AssetOverlayAsc = 'assetOverlay_ASC',
  AssetOverlayDesc = 'assetOverlay_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ContentTypeAssetLinkingCollectionsVideoCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  ControlsAsc = 'controls_ASC',
  ControlsDesc = 'controls_DESC',
  DurationAsc = 'duration_ASC',
  DurationDesc = 'duration_DESC',
  LoopAsc = 'loop_ASC',
  LoopDesc = 'loop_DESC',
  MutedAsc = 'muted_ASC',
  MutedDesc = 'muted_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  VimeoUrlAsc = 'vimeoUrl_ASC',
  VimeoUrlDesc = 'vimeoUrl_DESC'
}

export enum ContentTypeAssetOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  ControlsAsc = 'controls_ASC',
  ControlsDesc = 'controls_DESC',
  ImageUrlAsc = 'imageUrl_ASC',
  ImageUrlDesc = 'imageUrl_DESC',
  LoopAsc = 'loop_ASC',
  LoopDesc = 'loop_DESC',
  MutedAsc = 'muted_ASC',
  MutedDesc = 'muted_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VideoResolutionAsc = 'videoResolution_ASC',
  VideoResolutionDesc = 'videoResolution_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataFilter = {
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *     Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/cta) */
export type Cta = Entry & {
  __typename?: 'Cta';
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Scalars['String']>;
  iconPosition?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<CtaLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  newTab?: Maybe<Scalars['Boolean']>;
  sys: Sys;
  template?: Maybe<Scalars['String']>;
  url?: Maybe<Url>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/cta) */
export type CtaIconArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/cta) */
export type CtaIconPositionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/cta) */
export type CtaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/cta) */
export type CtaNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/cta) */
export type CtaNewTabArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/cta) */
export type CtaTemplateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/cta) */
export type CtaUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<UrlFilter>;
};

export type CtaCollection = {
  __typename?: 'CtaCollection';
  items: Array<Maybe<Cta>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CtaFilter = {
  AND?: InputMaybe<Array<InputMaybe<CtaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CtaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']>;
  iconPosition?: InputMaybe<Scalars['String']>;
  iconPosition_contains?: InputMaybe<Scalars['String']>;
  iconPosition_exists?: InputMaybe<Scalars['Boolean']>;
  iconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconPosition_not?: InputMaybe<Scalars['String']>;
  iconPosition_not_contains?: InputMaybe<Scalars['String']>;
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_contains?: InputMaybe<Scalars['String']>;
  icon_exists?: InputMaybe<Scalars['Boolean']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_not?: InputMaybe<Scalars['String']>;
  icon_not_contains?: InputMaybe<Scalars['String']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newTab?: InputMaybe<Scalars['Boolean']>;
  newTab_exists?: InputMaybe<Scalars['Boolean']>;
  newTab_not?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  template?: InputMaybe<Scalars['String']>;
  template_contains?: InputMaybe<Scalars['String']>;
  template_exists?: InputMaybe<Scalars['Boolean']>;
  template_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  template_not?: InputMaybe<Scalars['String']>;
  template_not_contains?: InputMaybe<Scalars['String']>;
  template_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<CfUrlNestedFilter>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
};

export type CtaLinkingCollections = {
  __typename?: 'CtaLinkingCollections';
  cardCollection?: Maybe<CardCollection>;
  entryCollection?: Maybe<EntryCollection>;
  heroSlideCollection?: Maybe<HeroSlideCollection>;
  sectionCollection?: Maybe<SectionCollection>;
};


export type CtaLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsHeroSlideCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsHeroSlideCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CtaLinkingCollectionsCardCollectionOrder {
  CardAspectRatioAsc = 'cardAspectRatio_ASC',
  CardAspectRatioDesc = 'cardAspectRatio_DESC',
  CardLayoutAsc = 'cardLayout_ASC',
  CardLayoutDesc = 'cardLayout_DESC',
  ContentLayoutAsc = 'contentLayout_ASC',
  ContentLayoutDesc = 'contentLayout_DESC',
  ContentSizeAsc = 'contentSize_ASC',
  ContentSizeDesc = 'contentSize_DESC',
  MarginsAsc = 'margins_ASC',
  MarginsDesc = 'margins_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  WidthLimitAsc = 'widthLimit_ASC',
  WidthLimitDesc = 'widthLimit_DESC'
}

export enum CtaLinkingCollectionsHeroSlideCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OverlayAssetAsc = 'overlayAsset_ASC',
  OverlayAssetDesc = 'overlayAsset_DESC',
  OverlayCtaLabelAsc = 'overlayCtaLabel_ASC',
  OverlayCtaLabelDesc = 'overlayCtaLabel_DESC',
  SlideAppearanceAsc = 'slideAppearance_ASC',
  SlideAppearanceDesc = 'slideAppearance_DESC',
  SlideTypeAsc = 'slideType_ASC',
  SlideTypeDesc = 'slideType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CtaLinkingCollectionsSectionCollectionOrder {
  ColumnsAsc = 'columns_ASC',
  ColumnsDesc = 'columns_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CtaOrder {
  IconPositionAsc = 'iconPosition_ASC',
  IconPositionDesc = 'iconPosition_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  NewTabAsc = 'newTab_ASC',
  NewTabDesc = 'newTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemplateAsc = 'template_ASC',
  TemplateDesc = 'template_DESC'
}

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/faq) */
export type Faq = Entry & {
  __typename?: 'Faq';
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<FaqLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  questionsCollection?: Maybe<FaqQuestionsCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/faq) */
export type FaqLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/faq) */
export type FaqNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/faq) */
export type FaqQuestionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FaqQuestionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextFilter>;
};

export type FaqCollection = {
  __typename?: 'FaqCollection';
  items: Array<Maybe<Faq>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type FaqFilter = {
  AND?: InputMaybe<Array<InputMaybe<FaqFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FaqFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questions?: InputMaybe<CfTextNestedFilter>;
  questionsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type FaqLinkingCollections = {
  __typename?: 'FaqLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type FaqLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FaqLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FaqLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum FaqLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum FaqOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type FaqQuestionsCollection = {
  __typename?: 'FaqQuestionsCollection';
  items: Array<Maybe<Text>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum FaqQuestionsCollectionOrder {
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Structural Component - Footer [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footer) */
export type Footer = Entry & {
  __typename?: 'Footer';
  addressesCollection?: Maybe<FooterAddressesCollection>;
  contentfulMetadata: ContentfulMetadata;
  copyright?: Maybe<Text>;
  facebookUrl?: Maybe<Scalars['String']>;
  instagramUrl?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<FooterLinkingCollections>;
  linkedInUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  primaryLinksCollection?: Maybe<FooterPrimaryLinksCollection>;
  secondaryLinksCollection?: Maybe<FooterSecondaryLinksCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
  twitterUrl?: Maybe<Scalars['String']>;
};


/** Structural Component - Footer [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footer) */
export type FooterAddressesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FooterAddressesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FooterAddressFilter>;
};


/** Structural Component - Footer [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footer) */
export type FooterCopyrightArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TextFilter>;
};


/** Structural Component - Footer [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footer) */
export type FooterFacebookUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural Component - Footer [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footer) */
export type FooterInstagramUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural Component - Footer [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footer) */
export type FooterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Structural Component - Footer [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footer) */
export type FooterLinkedInUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural Component - Footer [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footer) */
export type FooterNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural Component - Footer [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footer) */
export type FooterPrimaryLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FooterPrimaryLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UrlFilter>;
};


/** Structural Component - Footer [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footer) */
export type FooterSecondaryLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FooterSecondaryLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UrlFilter>;
};


/** Structural Component - Footer [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footer) */
export type FooterTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural Component - Footer [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footer) */
export type FooterTwitterUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footerAddress) */
export type FooterAddress = Entry & {
  __typename?: 'FooterAddress';
  addressFormat?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<FooterAddressLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  office?: Maybe<Office>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footerAddress) */
export type FooterAddressAddressFormatArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footerAddress) */
export type FooterAddressLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footerAddress) */
export type FooterAddressNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/footerAddress) */
export type FooterAddressOfficeArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<OfficeFilter>;
};

export type FooterAddressCollection = {
  __typename?: 'FooterAddressCollection';
  items: Array<Maybe<FooterAddress>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type FooterAddressFilter = {
  AND?: InputMaybe<Array<InputMaybe<FooterAddressFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FooterAddressFilter>>>;
  addressFormat?: InputMaybe<Scalars['String']>;
  addressFormat_contains?: InputMaybe<Scalars['String']>;
  addressFormat_exists?: InputMaybe<Scalars['Boolean']>;
  addressFormat_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressFormat_not?: InputMaybe<Scalars['String']>;
  addressFormat_not_contains?: InputMaybe<Scalars['String']>;
  addressFormat_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  office?: InputMaybe<CfOfficeNestedFilter>;
  office_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type FooterAddressLinkingCollections = {
  __typename?: 'FooterAddressLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  footerCollection?: Maybe<FooterCollection>;
  navigationCollection?: Maybe<NavigationCollection>;
};


export type FooterAddressLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FooterAddressLinkingCollectionsFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FooterAddressLinkingCollectionsFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FooterAddressLinkingCollectionsNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FooterAddressLinkingCollectionsNavigationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum FooterAddressLinkingCollectionsFooterCollectionOrder {
  FacebookUrlAsc = 'facebookUrl_ASC',
  FacebookUrlDesc = 'facebookUrl_DESC',
  InstagramUrlAsc = 'instagramUrl_ASC',
  InstagramUrlDesc = 'instagramUrl_DESC',
  LinkedInUrlAsc = 'linkedInUrl_ASC',
  LinkedInUrlDesc = 'linkedInUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterUrlAsc = 'twitterUrl_ASC',
  TwitterUrlDesc = 'twitterUrl_DESC'
}

export enum FooterAddressLinkingCollectionsNavigationCollectionOrder {
  FacebookUrlAsc = 'facebookUrl_ASC',
  FacebookUrlDesc = 'facebookUrl_DESC',
  InstagramUrlAsc = 'instagramUrl_ASC',
  InstagramUrlDesc = 'instagramUrl_DESC',
  LinkedInUrlAsc = 'linkedInUrl_ASC',
  LinkedInUrlDesc = 'linkedInUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TwitterUrlAsc = 'twitterUrl_ASC',
  TwitterUrlDesc = 'twitterUrl_DESC'
}

export enum FooterAddressOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type FooterAddressesCollection = {
  __typename?: 'FooterAddressesCollection';
  items: Array<Maybe<FooterAddress>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum FooterAddressesCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type FooterCollection = {
  __typename?: 'FooterCollection';
  items: Array<Maybe<Footer>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type FooterFilter = {
  AND?: InputMaybe<Array<InputMaybe<FooterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FooterFilter>>>;
  addresses?: InputMaybe<CfFooterAddressNestedFilter>;
  addressesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copyright?: InputMaybe<CfTextNestedFilter>;
  copyright_exists?: InputMaybe<Scalars['Boolean']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  facebookUrl_contains?: InputMaybe<Scalars['String']>;
  facebookUrl_exists?: InputMaybe<Scalars['Boolean']>;
  facebookUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookUrl_not?: InputMaybe<Scalars['String']>;
  facebookUrl_not_contains?: InputMaybe<Scalars['String']>;
  facebookUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  instagramUrl_contains?: InputMaybe<Scalars['String']>;
  instagramUrl_exists?: InputMaybe<Scalars['Boolean']>;
  instagramUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  instagramUrl_not?: InputMaybe<Scalars['String']>;
  instagramUrl_not_contains?: InputMaybe<Scalars['String']>;
  instagramUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkedInUrl?: InputMaybe<Scalars['String']>;
  linkedInUrl_contains?: InputMaybe<Scalars['String']>;
  linkedInUrl_exists?: InputMaybe<Scalars['Boolean']>;
  linkedInUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkedInUrl_not?: InputMaybe<Scalars['String']>;
  linkedInUrl_not_contains?: InputMaybe<Scalars['String']>;
  linkedInUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  primaryLinks?: InputMaybe<CfUrlNestedFilter>;
  primaryLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  secondaryLinks?: InputMaybe<CfUrlNestedFilter>;
  secondaryLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  twitterUrl_contains?: InputMaybe<Scalars['String']>;
  twitterUrl_exists?: InputMaybe<Scalars['Boolean']>;
  twitterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterUrl_not?: InputMaybe<Scalars['String']>;
  twitterUrl_not_contains?: InputMaybe<Scalars['String']>;
  twitterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FooterLinkingCollections = {
  __typename?: 'FooterLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type FooterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FooterLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FooterLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum FooterLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum FooterOrder {
  FacebookUrlAsc = 'facebookUrl_ASC',
  FacebookUrlDesc = 'facebookUrl_DESC',
  InstagramUrlAsc = 'instagramUrl_ASC',
  InstagramUrlDesc = 'instagramUrl_DESC',
  LinkedInUrlAsc = 'linkedInUrl_ASC',
  LinkedInUrlDesc = 'linkedInUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterUrlAsc = 'twitterUrl_ASC',
  TwitterUrlDesc = 'twitterUrl_DESC'
}

export type FooterPrimaryLinksCollection = {
  __typename?: 'FooterPrimaryLinksCollection';
  items: Array<Maybe<Url>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum FooterPrimaryLinksCollectionOrder {
  ContactFormRoleAsc = 'contactFormRole_ASC',
  ContactFormRoleDesc = 'contactFormRole_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LinkTypeAsc = 'linkType_ASC',
  LinkTypeDesc = 'linkType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QueryParametersAsc = 'queryParameters_ASC',
  QueryParametersDesc = 'queryParameters_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type FooterSecondaryLinksCollection = {
  __typename?: 'FooterSecondaryLinksCollection';
  items: Array<Maybe<Url>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum FooterSecondaryLinksCollectionOrder {
  ContactFormRoleAsc = 'contactFormRole_ASC',
  ContactFormRoleDesc = 'contactFormRole_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LinkTypeAsc = 'linkType_ASC',
  LinkTypeDesc = 'linkType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QueryParametersAsc = 'queryParameters_ASC',
  QueryParametersDesc = 'queryParameters_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/gallery) */
export type Gallery = Entry & {
  __typename?: 'Gallery';
  autoplay?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  imagesCollection?: Maybe<GalleryImagesCollection>;
  linkedFrom?: Maybe<GalleryLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  speed?: Maybe<Scalars['Int']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/gallery) */
export type GalleryAutoplayArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/gallery) */
export type GalleryImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<GalleryImagesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GalleryItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/gallery) */
export type GalleryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/gallery) */
export type GalleryNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/gallery) */
export type GallerySpeedArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type GalleryCollection = {
  __typename?: 'GalleryCollection';
  items: Array<Maybe<Gallery>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type GalleryFilter = {
  AND?: InputMaybe<Array<InputMaybe<GalleryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<GalleryFilter>>>;
  autoplay?: InputMaybe<Scalars['String']>;
  autoplay_contains?: InputMaybe<Scalars['String']>;
  autoplay_exists?: InputMaybe<Scalars['Boolean']>;
  autoplay_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoplay_not?: InputMaybe<Scalars['String']>;
  autoplay_not_contains?: InputMaybe<Scalars['String']>;
  autoplay_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  images?: InputMaybe<CfGalleryItemNestedFilter>;
  imagesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  speed?: InputMaybe<Scalars['Int']>;
  speed_exists?: InputMaybe<Scalars['Boolean']>;
  speed_gt?: InputMaybe<Scalars['Int']>;
  speed_gte?: InputMaybe<Scalars['Int']>;
  speed_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  speed_lt?: InputMaybe<Scalars['Int']>;
  speed_lte?: InputMaybe<Scalars['Int']>;
  speed_not?: InputMaybe<Scalars['Int']>;
  speed_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type GalleryImagesCollection = {
  __typename?: 'GalleryImagesCollection';
  items: Array<Maybe<GalleryItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum GalleryImagesCollectionOrder {
  ItemTypeAsc = 'itemType_ASC',
  ItemTypeDesc = 'itemType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/galleryItem) */
export type GalleryItem = Entry & {
  __typename?: 'GalleryItem';
  assetsCollection?: Maybe<GalleryItemAssetsCollection>;
  contentfulMetadata: ContentfulMetadata;
  itemType?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<GalleryItemLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  sys: Sys;
  text?: Maybe<Text>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/galleryItem) */
export type GalleryItemAssetsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemAssetsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentTypeAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/galleryItem) */
export type GalleryItemItemTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/galleryItem) */
export type GalleryItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/galleryItem) */
export type GalleryItemNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/galleryItem) */
export type GalleryItemTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TextFilter>;
};

export type GalleryItemAssetsCollection = {
  __typename?: 'GalleryItemAssetsCollection';
  items: Array<Maybe<ContentTypeAsset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum GalleryItemAssetsCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  ControlsAsc = 'controls_ASC',
  ControlsDesc = 'controls_DESC',
  ImageUrlAsc = 'imageUrl_ASC',
  ImageUrlDesc = 'imageUrl_DESC',
  LoopAsc = 'loop_ASC',
  LoopDesc = 'loop_DESC',
  MutedAsc = 'muted_ASC',
  MutedDesc = 'muted_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VideoResolutionAsc = 'videoResolution_ASC',
  VideoResolutionDesc = 'videoResolution_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type GalleryItemCollection = {
  __typename?: 'GalleryItemCollection';
  items: Array<Maybe<GalleryItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type GalleryItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<GalleryItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<GalleryItemFilter>>>;
  assets?: InputMaybe<CfContentTypeAssetNestedFilter>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  itemType?: InputMaybe<Scalars['String']>;
  itemType_contains?: InputMaybe<Scalars['String']>;
  itemType_exists?: InputMaybe<Scalars['Boolean']>;
  itemType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  itemType_not?: InputMaybe<Scalars['String']>;
  itemType_not_contains?: InputMaybe<Scalars['String']>;
  itemType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfTextNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
};

export type GalleryItemLinkingCollections = {
  __typename?: 'GalleryItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  galleryCollection?: Maybe<GalleryCollection>;
  timelineCollection?: Maybe<TimelineCollection>;
};


export type GalleryItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type GalleryItemLinkingCollectionsGalleryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemLinkingCollectionsGalleryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type GalleryItemLinkingCollectionsTimelineCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemLinkingCollectionsTimelineCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum GalleryItemLinkingCollectionsGalleryCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SpeedAsc = 'speed_ASC',
  SpeedDesc = 'speed_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GalleryItemLinkingCollectionsTimelineCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GalleryItemOrder {
  ItemTypeAsc = 'itemType_ASC',
  ItemTypeDesc = 'itemType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type GalleryLinkingCollections = {
  __typename?: 'GalleryLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type GalleryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type GalleryLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<GalleryLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum GalleryLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GalleryOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SpeedAsc = 'speed_ASC',
  SpeedDesc = 'speed_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/hero) */
export type Hero = Entry & {
  __typename?: 'Hero';
  contentfulMetadata: ContentfulMetadata;
  heroType?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<HeroLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  scrollCtaLabel?: Maybe<Scalars['String']>;
  slidesCollection?: Maybe<HeroSlidesCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/hero) */
export type HeroHeroTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/hero) */
export type HeroLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/hero) */
export type HeroNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/hero) */
export type HeroScrollCtaLabelArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/hero) */
export type HeroSlidesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroSlidesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HeroSlideFilter>;
};

export type HeroCollection = {
  __typename?: 'HeroCollection';
  items: Array<Maybe<Hero>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HeroFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeroFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  heroType?: InputMaybe<Scalars['String']>;
  heroType_contains?: InputMaybe<Scalars['String']>;
  heroType_exists?: InputMaybe<Scalars['Boolean']>;
  heroType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  heroType_not?: InputMaybe<Scalars['String']>;
  heroType_not_contains?: InputMaybe<Scalars['String']>;
  heroType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scrollCtaLabel?: InputMaybe<Scalars['String']>;
  scrollCtaLabel_contains?: InputMaybe<Scalars['String']>;
  scrollCtaLabel_exists?: InputMaybe<Scalars['Boolean']>;
  scrollCtaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scrollCtaLabel_not?: InputMaybe<Scalars['String']>;
  scrollCtaLabel_not_contains?: InputMaybe<Scalars['String']>;
  scrollCtaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slides?: InputMaybe<CfHeroSlideNestedFilter>;
  slidesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type HeroLinkingCollections = {
  __typename?: 'HeroLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type HeroLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type HeroLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum HeroLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum HeroOrder {
  HeroTypeAsc = 'heroType_ASC',
  HeroTypeDesc = 'heroType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ScrollCtaLabelAsc = 'scrollCtaLabel_ASC',
  ScrollCtaLabelDesc = 'scrollCtaLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/heroSlide) */
export type HeroSlide = Entry & {
  __typename?: 'HeroSlide';
  assetsCollection?: Maybe<HeroSlideAssetsCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<HeroSlideLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  overlayAsset?: Maybe<Scalars['String']>;
  overlayButtonsCollection?: Maybe<HeroSlideOverlayButtonsCollection>;
  overlayCtaLabel?: Maybe<Scalars['String']>;
  overlayText?: Maybe<Text>;
  slideAppearance?: Maybe<Scalars['String']>;
  slideTextCollection?: Maybe<HeroSlideSlideTextCollection>;
  slideType?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/heroSlide) */
export type HeroSlideAssetsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroSlideAssetsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentTypeAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/heroSlide) */
export type HeroSlideLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/heroSlide) */
export type HeroSlideNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/heroSlide) */
export type HeroSlideOverlayAssetArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/heroSlide) */
export type HeroSlideOverlayButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroSlideOverlayButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/heroSlide) */
export type HeroSlideOverlayCtaLabelArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/heroSlide) */
export type HeroSlideOverlayTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/heroSlide) */
export type HeroSlideSlideAppearanceArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/heroSlide) */
export type HeroSlideSlideTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroSlideSlideTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/heroSlide) */
export type HeroSlideSlideTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type HeroSlideAssetsCollection = {
  __typename?: 'HeroSlideAssetsCollection';
  items: Array<Maybe<ContentTypeAsset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum HeroSlideAssetsCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  ControlsAsc = 'controls_ASC',
  ControlsDesc = 'controls_DESC',
  ImageUrlAsc = 'imageUrl_ASC',
  ImageUrlDesc = 'imageUrl_DESC',
  LoopAsc = 'loop_ASC',
  LoopDesc = 'loop_DESC',
  MutedAsc = 'muted_ASC',
  MutedDesc = 'muted_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VideoResolutionAsc = 'videoResolution_ASC',
  VideoResolutionDesc = 'videoResolution_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type HeroSlideCollection = {
  __typename?: 'HeroSlideCollection';
  items: Array<Maybe<HeroSlide>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HeroSlideFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeroSlideFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroSlideFilter>>>;
  assets?: InputMaybe<CfContentTypeAssetNestedFilter>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overlayAsset?: InputMaybe<Scalars['String']>;
  overlayAsset_contains?: InputMaybe<Scalars['String']>;
  overlayAsset_exists?: InputMaybe<Scalars['Boolean']>;
  overlayAsset_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overlayAsset_not?: InputMaybe<Scalars['String']>;
  overlayAsset_not_contains?: InputMaybe<Scalars['String']>;
  overlayAsset_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overlayButtons?: InputMaybe<CfCtaNestedFilter>;
  overlayButtonsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  overlayCtaLabel?: InputMaybe<Scalars['String']>;
  overlayCtaLabel_contains?: InputMaybe<Scalars['String']>;
  overlayCtaLabel_exists?: InputMaybe<Scalars['Boolean']>;
  overlayCtaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overlayCtaLabel_not?: InputMaybe<Scalars['String']>;
  overlayCtaLabel_not_contains?: InputMaybe<Scalars['String']>;
  overlayCtaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overlayText?: InputMaybe<CfTextNestedFilter>;
  overlayText_exists?: InputMaybe<Scalars['Boolean']>;
  slideAppearance?: InputMaybe<Scalars['String']>;
  slideAppearance_contains?: InputMaybe<Scalars['String']>;
  slideAppearance_exists?: InputMaybe<Scalars['Boolean']>;
  slideAppearance_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slideAppearance_not?: InputMaybe<Scalars['String']>;
  slideAppearance_not_contains?: InputMaybe<Scalars['String']>;
  slideAppearance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slideText?: InputMaybe<CfTextNestedFilter>;
  slideTextCollection_exists?: InputMaybe<Scalars['Boolean']>;
  slideType?: InputMaybe<Scalars['String']>;
  slideType_contains?: InputMaybe<Scalars['String']>;
  slideType_exists?: InputMaybe<Scalars['Boolean']>;
  slideType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slideType_not?: InputMaybe<Scalars['String']>;
  slideType_not_contains?: InputMaybe<Scalars['String']>;
  slideType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeroSlideLinkingCollections = {
  __typename?: 'HeroSlideLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  heroCollection?: Maybe<HeroCollection>;
};


export type HeroSlideLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type HeroSlideLinkingCollectionsHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroSlideLinkingCollectionsHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum HeroSlideLinkingCollectionsHeroCollectionOrder {
  HeroTypeAsc = 'heroType_ASC',
  HeroTypeDesc = 'heroType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ScrollCtaLabelAsc = 'scrollCtaLabel_ASC',
  ScrollCtaLabelDesc = 'scrollCtaLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum HeroSlideOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OverlayAssetAsc = 'overlayAsset_ASC',
  OverlayAssetDesc = 'overlayAsset_DESC',
  OverlayCtaLabelAsc = 'overlayCtaLabel_ASC',
  OverlayCtaLabelDesc = 'overlayCtaLabel_DESC',
  SlideAppearanceAsc = 'slideAppearance_ASC',
  SlideAppearanceDesc = 'slideAppearance_DESC',
  SlideTypeAsc = 'slideType_ASC',
  SlideTypeDesc = 'slideType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type HeroSlideOverlayButtonsCollection = {
  __typename?: 'HeroSlideOverlayButtonsCollection';
  items: Array<Maybe<Cta>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum HeroSlideOverlayButtonsCollectionOrder {
  IconPositionAsc = 'iconPosition_ASC',
  IconPositionDesc = 'iconPosition_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  NewTabAsc = 'newTab_ASC',
  NewTabDesc = 'newTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemplateAsc = 'template_ASC',
  TemplateDesc = 'template_DESC'
}

export type HeroSlideSlideTextCollection = {
  __typename?: 'HeroSlideSlideTextCollection';
  items: Array<Maybe<Text>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum HeroSlideSlideTextCollectionOrder {
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type HeroSlidesCollection = {
  __typename?: 'HeroSlidesCollection';
  items: Array<Maybe<HeroSlide>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum HeroSlidesCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OverlayAssetAsc = 'overlayAsset_ASC',
  OverlayAssetDesc = 'overlayAsset_DESC',
  OverlayCtaLabelAsc = 'overlayCtaLabel_ASC',
  OverlayCtaLabelDesc = 'overlayCtaLabel_DESC',
  SlideAppearanceAsc = 'slideAppearance_ASC',
  SlideAppearanceDesc = 'slideAppearance_DESC',
  SlideTypeAsc = 'slideType_ASC',
  SlideTypeDesc = 'slideType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/html) */
export type Html = Entry & {
  __typename?: 'Html';
  contentfulMetadata: ContentfulMetadata;
  html?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<HtmlLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/html) */
export type HtmlHtmlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/html) */
export type HtmlLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/html) */
export type HtmlNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type HtmlCollection = {
  __typename?: 'HtmlCollection';
  items: Array<Maybe<Html>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HtmlFilter = {
  AND?: InputMaybe<Array<InputMaybe<HtmlFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HtmlFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  html?: InputMaybe<Scalars['String']>;
  html_contains?: InputMaybe<Scalars['String']>;
  html_exists?: InputMaybe<Scalars['Boolean']>;
  html_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  html_not?: InputMaybe<Scalars['String']>;
  html_not_contains?: InputMaybe<Scalars['String']>;
  html_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HtmlLinkingCollections = {
  __typename?: 'HtmlLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type HtmlLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type HtmlLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HtmlLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum HtmlLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum HtmlOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageFormat {
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']>;
};

/** Listing component for Structured Data [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/list) */
export type List = Entry & {
  __typename?: 'List';
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ListLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  sys: Sys;
  type?: Maybe<Scalars['String']>;
};


/** Listing component for Structured Data [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/list) */
export type ListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Listing component for Structured Data [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/list) */
export type ListNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Listing component for Structured Data [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/list) */
export type ListTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ListCollection = {
  __typename?: 'ListCollection';
  items: Array<Maybe<List>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ListFilter = {
  AND?: InputMaybe<Array<InputMaybe<ListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ListFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListLinkingCollections = {
  __typename?: 'ListLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type ListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ListLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ListLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ListLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ListOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** Media Block consumes Asset to render in-page [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/media) */
export type Media = Entry & {
  __typename?: 'Media';
  assetsCollection?: Maybe<MediaAssetsCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<MediaLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** Media Block consumes Asset to render in-page [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/media) */
export type MediaAssetsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MediaAssetsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentTypeAssetFilter>;
};


/** Media Block consumes Asset to render in-page [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/media) */
export type MediaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Media Block consumes Asset to render in-page [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/media) */
export type MediaNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type MediaAssetsCollection = {
  __typename?: 'MediaAssetsCollection';
  items: Array<Maybe<ContentTypeAsset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum MediaAssetsCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  ControlsAsc = 'controls_ASC',
  ControlsDesc = 'controls_DESC',
  ImageUrlAsc = 'imageUrl_ASC',
  ImageUrlDesc = 'imageUrl_DESC',
  LoopAsc = 'loop_ASC',
  LoopDesc = 'loop_DESC',
  MutedAsc = 'muted_ASC',
  MutedDesc = 'muted_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VideoResolutionAsc = 'videoResolution_ASC',
  VideoResolutionDesc = 'videoResolution_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type MediaCollection = {
  __typename?: 'MediaCollection';
  items: Array<Maybe<Media>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type MediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<MediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MediaFilter>>>;
  assets?: InputMaybe<CfContentTypeAssetNestedFilter>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type MediaLinkingCollections = {
  __typename?: 'MediaLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type MediaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type MediaLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MediaLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum MediaLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum MediaOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/metaData) */
export type MetaData = Entry & {
  __typename?: 'MetaData';
  assetsCollection?: Maybe<MetaDataAssetsCollection>;
  contentfulMetadata: ContentfulMetadata;
  context?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<MetaDataLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/metaData) */
export type MetaDataAssetsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MetaDataAssetsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentTypeAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/metaData) */
export type MetaDataContextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/metaData) */
export type MetaDataDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/metaData) */
export type MetaDataLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/metaData) */
export type MetaDataNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/metaData) */
export type MetaDataTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type MetaDataAssetsCollection = {
  __typename?: 'MetaDataAssetsCollection';
  items: Array<Maybe<ContentTypeAsset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum MetaDataAssetsCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  ControlsAsc = 'controls_ASC',
  ControlsDesc = 'controls_DESC',
  ImageUrlAsc = 'imageUrl_ASC',
  ImageUrlDesc = 'imageUrl_DESC',
  LoopAsc = 'loop_ASC',
  LoopDesc = 'loop_DESC',
  MutedAsc = 'muted_ASC',
  MutedDesc = 'muted_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VideoResolutionAsc = 'videoResolution_ASC',
  VideoResolutionDesc = 'videoResolution_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type MetaDataCollection = {
  __typename?: 'MetaDataCollection';
  items: Array<Maybe<MetaData>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type MetaDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<MetaDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MetaDataFilter>>>;
  assets?: InputMaybe<CfContentTypeAssetNestedFilter>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  context_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  context_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  context_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  context_exists?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MetaDataLinkingCollections = {
  __typename?: 'MetaDataLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type MetaDataLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type MetaDataLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MetaDataLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum MetaDataLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum MetaDataOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Structural Component - Navigation [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/navigation) */
export type Navigation = Entry & {
  __typename?: 'Navigation';
  addressesCollection?: Maybe<NavigationAddressesCollection>;
  contentfulMetadata: ContentfulMetadata;
  copyright?: Maybe<Text>;
  facebookUrl?: Maybe<Scalars['String']>;
  instagramUrl?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<NavigationLinkingCollections>;
  linkedInUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  primaryLinksCollection?: Maybe<NavigationPrimaryLinksCollection>;
  secondaryLinksCollection?: Maybe<NavigationSecondaryLinksCollection>;
  sys: Sys;
  twitterUrl?: Maybe<Scalars['String']>;
};


/** Structural Component - Navigation [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/navigation) */
export type NavigationAddressesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationAddressesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FooterAddressFilter>;
};


/** Structural Component - Navigation [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/navigation) */
export type NavigationCopyrightArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TextFilter>;
};


/** Structural Component - Navigation [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/navigation) */
export type NavigationFacebookUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural Component - Navigation [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/navigation) */
export type NavigationInstagramUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural Component - Navigation [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/navigation) */
export type NavigationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Structural Component - Navigation [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/navigation) */
export type NavigationLinkedInUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural Component - Navigation [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/navigation) */
export type NavigationNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural Component - Navigation [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/navigation) */
export type NavigationPrimaryLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationPrimaryLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UrlFilter>;
};


/** Structural Component - Navigation [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/navigation) */
export type NavigationSecondaryLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationSecondaryLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UrlFilter>;
};


/** Structural Component - Navigation [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/navigation) */
export type NavigationTwitterUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type NavigationAddressesCollection = {
  __typename?: 'NavigationAddressesCollection';
  items: Array<Maybe<FooterAddress>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum NavigationAddressesCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type NavigationCollection = {
  __typename?: 'NavigationCollection';
  items: Array<Maybe<Navigation>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type NavigationFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationFilter>>>;
  addresses?: InputMaybe<CfFooterAddressNestedFilter>;
  addressesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copyright?: InputMaybe<CfTextNestedFilter>;
  copyright_exists?: InputMaybe<Scalars['Boolean']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  facebookUrl_contains?: InputMaybe<Scalars['String']>;
  facebookUrl_exists?: InputMaybe<Scalars['Boolean']>;
  facebookUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  facebookUrl_not?: InputMaybe<Scalars['String']>;
  facebookUrl_not_contains?: InputMaybe<Scalars['String']>;
  facebookUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  instagramUrl_contains?: InputMaybe<Scalars['String']>;
  instagramUrl_exists?: InputMaybe<Scalars['Boolean']>;
  instagramUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  instagramUrl_not?: InputMaybe<Scalars['String']>;
  instagramUrl_not_contains?: InputMaybe<Scalars['String']>;
  instagramUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkedInUrl?: InputMaybe<Scalars['String']>;
  linkedInUrl_contains?: InputMaybe<Scalars['String']>;
  linkedInUrl_exists?: InputMaybe<Scalars['Boolean']>;
  linkedInUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkedInUrl_not?: InputMaybe<Scalars['String']>;
  linkedInUrl_not_contains?: InputMaybe<Scalars['String']>;
  linkedInUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  primaryLinks?: InputMaybe<CfUrlNestedFilter>;
  primaryLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  secondaryLinks?: InputMaybe<CfUrlNestedFilter>;
  secondaryLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  twitterUrl_contains?: InputMaybe<Scalars['String']>;
  twitterUrl_exists?: InputMaybe<Scalars['Boolean']>;
  twitterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterUrl_not?: InputMaybe<Scalars['String']>;
  twitterUrl_not_contains?: InputMaybe<Scalars['String']>;
  twitterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NavigationLinkingCollections = {
  __typename?: 'NavigationLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type NavigationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum NavigationOrder {
  FacebookUrlAsc = 'facebookUrl_ASC',
  FacebookUrlDesc = 'facebookUrl_DESC',
  InstagramUrlAsc = 'instagramUrl_ASC',
  InstagramUrlDesc = 'instagramUrl_DESC',
  LinkedInUrlAsc = 'linkedInUrl_ASC',
  LinkedInUrlDesc = 'linkedInUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TwitterUrlAsc = 'twitterUrl_ASC',
  TwitterUrlDesc = 'twitterUrl_DESC'
}

export type NavigationPrimaryLinksCollection = {
  __typename?: 'NavigationPrimaryLinksCollection';
  items: Array<Maybe<Url>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum NavigationPrimaryLinksCollectionOrder {
  ContactFormRoleAsc = 'contactFormRole_ASC',
  ContactFormRoleDesc = 'contactFormRole_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LinkTypeAsc = 'linkType_ASC',
  LinkTypeDesc = 'linkType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QueryParametersAsc = 'queryParameters_ASC',
  QueryParametersDesc = 'queryParameters_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type NavigationSecondaryLinksCollection = {
  __typename?: 'NavigationSecondaryLinksCollection';
  items: Array<Maybe<Url>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum NavigationSecondaryLinksCollectionOrder {
  ContactFormRoleAsc = 'contactFormRole_ASC',
  ContactFormRoleDesc = 'contactFormRole_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LinkTypeAsc = 'linkType_ASC',
  LinkTypeDesc = 'linkType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QueryParametersAsc = 'queryParameters_ASC',
  QueryParametersDesc = 'queryParameters_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type News = Entry & {
  __typename?: 'News';
  article?: Maybe<NewsArticle>;
  assetOverlay?: Maybe<Scalars['String']>;
  assetsCollection?: Maybe<NewsAssetsCollection>;
  contentfulMetadata: ContentfulMetadata;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<NewsLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  organizationLogo?: Maybe<Asset>;
  subtitle?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Url>;
};


/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type NewsArticleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type NewsAssetOverlayArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type NewsAssetsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NewsAssetsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentTypeAssetFilter>;
};


/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type NewsDateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type NewsDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type NewsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type NewsNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type NewsOrganizationLogoArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type NewsSubtitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type NewsTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type NewsTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structured Data for News [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/news) */
export type NewsUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<UrlFilter>;
};

export type NewsArticle = {
  __typename?: 'NewsArticle';
  json: Scalars['JSON'];
  links: NewsArticleLinks;
};

export type NewsArticleAssets = {
  __typename?: 'NewsArticleAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type NewsArticleEntries = {
  __typename?: 'NewsArticleEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type NewsArticleLinks = {
  __typename?: 'NewsArticleLinks';
  assets: NewsArticleAssets;
  entries: NewsArticleEntries;
  resources: NewsArticleResources;
};

export type NewsArticleResources = {
  __typename?: 'NewsArticleResources';
  block: Array<ResourceLink>;
  hyperlink: Array<ResourceLink>;
  inline: Array<ResourceLink>;
};

export type NewsAssetsCollection = {
  __typename?: 'NewsAssetsCollection';
  items: Array<Maybe<ContentTypeAsset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum NewsAssetsCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  ControlsAsc = 'controls_ASC',
  ControlsDesc = 'controls_DESC',
  ImageUrlAsc = 'imageUrl_ASC',
  ImageUrlDesc = 'imageUrl_DESC',
  LoopAsc = 'loop_ASC',
  LoopDesc = 'loop_DESC',
  MutedAsc = 'muted_ASC',
  MutedDesc = 'muted_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VideoResolutionAsc = 'videoResolution_ASC',
  VideoResolutionDesc = 'videoResolution_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type NewsCollection = {
  __typename?: 'NewsCollection';
  items: Array<Maybe<News>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type NewsFilter = {
  AND?: InputMaybe<Array<InputMaybe<NewsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NewsFilter>>>;
  article_contains?: InputMaybe<Scalars['String']>;
  article_exists?: InputMaybe<Scalars['Boolean']>;
  article_not_contains?: InputMaybe<Scalars['String']>;
  assetOverlay?: InputMaybe<Scalars['String']>;
  assetOverlay_contains?: InputMaybe<Scalars['String']>;
  assetOverlay_exists?: InputMaybe<Scalars['Boolean']>;
  assetOverlay_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  assetOverlay_not?: InputMaybe<Scalars['String']>;
  assetOverlay_not_contains?: InputMaybe<Scalars['String']>;
  assetOverlay_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  assets?: InputMaybe<CfContentTypeAssetNestedFilter>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  date?: InputMaybe<Scalars['DateTime']>;
  date_exists?: InputMaybe<Scalars['Boolean']>;
  date_gt?: InputMaybe<Scalars['DateTime']>;
  date_gte?: InputMaybe<Scalars['DateTime']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  date_lt?: InputMaybe<Scalars['DateTime']>;
  date_lte?: InputMaybe<Scalars['DateTime']>;
  date_not?: InputMaybe<Scalars['DateTime']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organizationLogo_exists?: InputMaybe<Scalars['Boolean']>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitle_contains?: InputMaybe<Scalars['String']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle_not?: InputMaybe<Scalars['String']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<CfUrlNestedFilter>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
};

export type NewsLinkingCollections = {
  __typename?: 'NewsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
  sectionCollection?: Maybe<SectionCollection>;
};


export type NewsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NewsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NewsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NewsLinkingCollectionsSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NewsLinkingCollectionsSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum NewsLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum NewsLinkingCollectionsSectionCollectionOrder {
  ColumnsAsc = 'columns_ASC',
  ColumnsDesc = 'columns_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum NewsOrder {
  AssetOverlayAsc = 'assetOverlay_ASC',
  AssetOverlayDesc = 'assetOverlay_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type Office = Entry & {
  __typename?: 'Office';
  addressCountry?: Maybe<Scalars['String']>;
  addressLocality?: Maybe<Scalars['String']>;
  addressRegion?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  email?: Maybe<Scalars['String']>;
  googleMapsLink?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<OfficeLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  streetAddressLine1?: Maybe<Scalars['String']>;
  streetAddressLine2?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
  ukCompanyNumber?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficeAddressCountryArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficeAddressLocalityArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficeAddressRegionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficeEmailArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficeGoogleMapsLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficeLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficeNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficePhoneArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficePostalCodeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficeStreetAddressLine1Args = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficeStreetAddressLine2Args = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficeTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/office) */
export type OfficeUkCompanyNumberArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type OfficeCollection = {
  __typename?: 'OfficeCollection';
  items: Array<Maybe<Office>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type OfficeFilter = {
  AND?: InputMaybe<Array<InputMaybe<OfficeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<OfficeFilter>>>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressCountry_contains?: InputMaybe<Scalars['String']>;
  addressCountry_exists?: InputMaybe<Scalars['Boolean']>;
  addressCountry_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressCountry_not?: InputMaybe<Scalars['String']>;
  addressCountry_not_contains?: InputMaybe<Scalars['String']>;
  addressCountry_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressLocality?: InputMaybe<Scalars['String']>;
  addressLocality_contains?: InputMaybe<Scalars['String']>;
  addressLocality_exists?: InputMaybe<Scalars['Boolean']>;
  addressLocality_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressLocality_not?: InputMaybe<Scalars['String']>;
  addressLocality_not_contains?: InputMaybe<Scalars['String']>;
  addressLocality_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressRegion?: InputMaybe<Scalars['String']>;
  addressRegion_contains?: InputMaybe<Scalars['String']>;
  addressRegion_exists?: InputMaybe<Scalars['Boolean']>;
  addressRegion_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressRegion_not?: InputMaybe<Scalars['String']>;
  addressRegion_not_contains?: InputMaybe<Scalars['String']>;
  addressRegion_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  email?: InputMaybe<Scalars['String']>;
  email_contains?: InputMaybe<Scalars['String']>;
  email_exists?: InputMaybe<Scalars['Boolean']>;
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email_not?: InputMaybe<Scalars['String']>;
  email_not_contains?: InputMaybe<Scalars['String']>;
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleMapsLink?: InputMaybe<Scalars['String']>;
  googleMapsLink_contains?: InputMaybe<Scalars['String']>;
  googleMapsLink_exists?: InputMaybe<Scalars['Boolean']>;
  googleMapsLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleMapsLink_not?: InputMaybe<Scalars['String']>;
  googleMapsLink_not_contains?: InputMaybe<Scalars['String']>;
  googleMapsLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phone?: InputMaybe<Scalars['String']>;
  phone_contains?: InputMaybe<Scalars['String']>;
  phone_exists?: InputMaybe<Scalars['Boolean']>;
  phone_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phone_not?: InputMaybe<Scalars['String']>;
  phone_not_contains?: InputMaybe<Scalars['String']>;
  phone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  postalCode?: InputMaybe<Scalars['String']>;
  postalCode_contains?: InputMaybe<Scalars['String']>;
  postalCode_exists?: InputMaybe<Scalars['Boolean']>;
  postalCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  postalCode_not?: InputMaybe<Scalars['String']>;
  postalCode_not_contains?: InputMaybe<Scalars['String']>;
  postalCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddressLine1?: InputMaybe<Scalars['String']>;
  streetAddressLine1_contains?: InputMaybe<Scalars['String']>;
  streetAddressLine1_exists?: InputMaybe<Scalars['Boolean']>;
  streetAddressLine1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddressLine1_not?: InputMaybe<Scalars['String']>;
  streetAddressLine1_not_contains?: InputMaybe<Scalars['String']>;
  streetAddressLine1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddressLine2?: InputMaybe<Scalars['String']>;
  streetAddressLine2_contains?: InputMaybe<Scalars['String']>;
  streetAddressLine2_exists?: InputMaybe<Scalars['Boolean']>;
  streetAddressLine2_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddressLine2_not?: InputMaybe<Scalars['String']>;
  streetAddressLine2_not_contains?: InputMaybe<Scalars['String']>;
  streetAddressLine2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ukCompanyNumber?: InputMaybe<Scalars['String']>;
  ukCompanyNumber_contains?: InputMaybe<Scalars['String']>;
  ukCompanyNumber_exists?: InputMaybe<Scalars['Boolean']>;
  ukCompanyNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ukCompanyNumber_not?: InputMaybe<Scalars['String']>;
  ukCompanyNumber_not_contains?: InputMaybe<Scalars['String']>;
  ukCompanyNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OfficeLinkingCollections = {
  __typename?: 'OfficeLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  footerAddressCollection?: Maybe<FooterAddressCollection>;
};


export type OfficeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type OfficeLinkingCollectionsFooterAddressCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<OfficeLinkingCollectionsFooterAddressCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum OfficeLinkingCollectionsFooterAddressCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum OfficeOrder {
  AddressCountryAsc = 'addressCountry_ASC',
  AddressCountryDesc = 'addressCountry_DESC',
  AddressLocalityAsc = 'addressLocality_ASC',
  AddressLocalityDesc = 'addressLocality_DESC',
  AddressRegionAsc = 'addressRegion_ASC',
  AddressRegionDesc = 'addressRegion_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GoogleMapsLinkAsc = 'googleMapsLink_ASC',
  GoogleMapsLinkDesc = 'googleMapsLink_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PhoneAsc = 'phone_ASC',
  PhoneDesc = 'phone_DESC',
  PostalCodeAsc = 'postalCode_ASC',
  PostalCodeDesc = 'postalCode_DESC',
  StreetAddressLine1Asc = 'streetAddressLine1_ASC',
  StreetAddressLine1Desc = 'streetAddressLine1_DESC',
  StreetAddressLine2Asc = 'streetAddressLine2_ASC',
  StreetAddressLine2Desc = 'streetAddressLine2_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UkCompanyNumberAsc = 'ukCompanyNumber_ASC',
  UkCompanyNumberDesc = 'ukCompanyNumber_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/page) */
export type Page = Entry & {
  __typename?: 'Page';
  contentCollection?: Maybe<PageContentCollection>;
  contentfulMetadata: ContentfulMetadata;
  country?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Array<Maybe<Scalars['String']>>>;
  linkedFrom?: Maybe<PageLinkingCollections>;
  metaDataCollection?: Maybe<PageMetaDataCollection>;
  name?: Maybe<Scalars['String']>;
  pageType?: Maybe<Scalars['String']>;
  parentPage?: Maybe<Page>;
  robots?: Maybe<SeoSitemapRules>;
  slug?: Maybe<Scalars['String']>;
  structuredDataCollection?: Maybe<PageStructuredDataCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/page) */
export type PageContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/page) */
export type PageCountryArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/page) */
export type PageLanguageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/page) */
export type PageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/page) */
export type PageMetaDataCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageMetaDataCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MetaDataFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/page) */
export type PageNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/page) */
export type PagePageTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/page) */
export type PageParentPageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/page) */
export type PageRobotsArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<SeoSitemapRulesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/page) */
export type PageSlugArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/page) */
export type PageStructuredDataCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageStructuredDataCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NewsFilter>;
};

export type PageCollection = {
  __typename?: 'PageCollection';
  items: Array<Maybe<Page>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type PageContentCollection = {
  __typename?: 'PageContentCollection';
  items: Array<Maybe<PageContentItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type PageContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PageContentItem = Card | Carousel | Faq | Footer | Gallery | Hero | Html | List | Media | Section | Timeline | Video;

export type PageFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  content?: InputMaybe<CfcontentMultiTypeNestedFilter>;
  contentCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  country_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country_exists?: InputMaybe<Scalars['Boolean']>;
  language_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language_exists?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<CfMetaDataNestedFilter>;
  metaDataCollection_exists?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageType?: InputMaybe<Scalars['String']>;
  pageType_contains?: InputMaybe<Scalars['String']>;
  pageType_exists?: InputMaybe<Scalars['Boolean']>;
  pageType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageType_not?: InputMaybe<Scalars['String']>;
  pageType_not_contains?: InputMaybe<Scalars['String']>;
  pageType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentPage?: InputMaybe<CfPageNestedFilter>;
  parentPage_exists?: InputMaybe<Scalars['Boolean']>;
  robots?: InputMaybe<CfSeoSitemapRulesNestedFilter>;
  robots_exists?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structuredData?: InputMaybe<CfNewsNestedFilter>;
  structuredDataCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type PageLinkingCollections = {
  __typename?: 'PageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
  urlCollection?: Maybe<UrlCollection>;
};


export type PageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PageLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PageLinkingCollectionsUrlCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsUrlCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum PageLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PageLinkingCollectionsUrlCollectionOrder {
  ContactFormRoleAsc = 'contactFormRole_ASC',
  ContactFormRoleDesc = 'contactFormRole_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LinkTypeAsc = 'linkType_ASC',
  LinkTypeDesc = 'linkType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QueryParametersAsc = 'queryParameters_ASC',
  QueryParametersDesc = 'queryParameters_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PageMetaDataCollection = {
  __typename?: 'PageMetaDataCollection';
  items: Array<Maybe<MetaData>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PageMetaDataCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PageStructuredDataCollection = {
  __typename?: 'PageStructuredDataCollection';
  items: Array<Maybe<News>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PageStructuredDataCollectionOrder {
  AssetOverlayAsc = 'assetOverlay_ASC',
  AssetOverlayDesc = 'assetOverlay_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type Query = {
  __typename?: 'Query';
  _node?: Maybe<_Node>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  card?: Maybe<Card>;
  cardCollection?: Maybe<CardCollection>;
  carousel?: Maybe<Carousel>;
  carouselCollection?: Maybe<CarouselCollection>;
  contentTypeAsset?: Maybe<ContentTypeAsset>;
  contentTypeAssetCollection?: Maybe<ContentTypeAssetCollection>;
  cta?: Maybe<Cta>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  faq?: Maybe<Faq>;
  faqCollection?: Maybe<FaqCollection>;
  footer?: Maybe<Footer>;
  footerAddress?: Maybe<FooterAddress>;
  footerAddressCollection?: Maybe<FooterAddressCollection>;
  footerCollection?: Maybe<FooterCollection>;
  gallery?: Maybe<Gallery>;
  galleryCollection?: Maybe<GalleryCollection>;
  galleryItem?: Maybe<GalleryItem>;
  galleryItemCollection?: Maybe<GalleryItemCollection>;
  hero?: Maybe<Hero>;
  heroCollection?: Maybe<HeroCollection>;
  heroSlide?: Maybe<HeroSlide>;
  heroSlideCollection?: Maybe<HeroSlideCollection>;
  html?: Maybe<Html>;
  htmlCollection?: Maybe<HtmlCollection>;
  list?: Maybe<List>;
  listCollection?: Maybe<ListCollection>;
  media?: Maybe<Media>;
  mediaCollection?: Maybe<MediaCollection>;
  metaData?: Maybe<MetaData>;
  metaDataCollection?: Maybe<MetaDataCollection>;
  navigation?: Maybe<Navigation>;
  navigationCollection?: Maybe<NavigationCollection>;
  news?: Maybe<News>;
  newsCollection?: Maybe<NewsCollection>;
  office?: Maybe<Office>;
  officeCollection?: Maybe<OfficeCollection>;
  page?: Maybe<Page>;
  pageCollection?: Maybe<PageCollection>;
  section?: Maybe<Section>;
  sectionCollection?: Maybe<SectionCollection>;
  seoSitemapRules?: Maybe<SeoSitemapRules>;
  seoSitemapRulesCollection?: Maybe<SeoSitemapRulesCollection>;
  text?: Maybe<Text>;
  textCollection?: Maybe<TextCollection>;
  timeline?: Maybe<Timeline>;
  timelineCollection?: Maybe<TimelineCollection>;
  url?: Maybe<Url>;
  urlCollection?: Maybe<UrlCollection>;
  video?: Maybe<Video>;
  videoCollection?: Maybe<VideoCollection>;
};


export type Query_NodeArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAssetArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryCardArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CardFilter>;
};


export type QueryCarouselArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CarouselOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CarouselFilter>;
};


export type QueryContentTypeAssetArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryContentTypeAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeAssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentTypeAssetFilter>;
};


export type QueryCtaArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CtaFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryFaqArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FaqOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FaqFilter>;
};


export type QueryFooterArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFooterAddressArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFooterAddressCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FooterAddressOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FooterAddressFilter>;
};


export type QueryFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FooterOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FooterFilter>;
};


export type QueryGalleryArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGalleryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<GalleryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GalleryFilter>;
};


export type QueryGalleryItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGalleryItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GalleryItemFilter>;
};


export type QueryHeroArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HeroFilter>;
};


export type QueryHeroSlideArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHeroSlideCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroSlideOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HeroSlideFilter>;
};


export type QueryHtmlArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHtmlCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HtmlOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HtmlFilter>;
};


export type QueryListArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ListFilter>;
};


export type QueryMediaArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMediaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MediaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MediaFilter>;
};


export type QueryMetaDataArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMetaDataCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MetaDataOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MetaDataFilter>;
};


export type QueryNavigationArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationFilter>;
};


export type QueryNewsArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NewsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NewsFilter>;
};


export type QueryOfficeArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOfficeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<OfficeOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OfficeFilter>;
};


export type QueryPageArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageFilter>;
};


export type QuerySectionArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionFilter>;
};


export type QuerySeoSitemapRulesArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySeoSitemapRulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SeoSitemapRulesOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeoSitemapRulesFilter>;
};


export type QueryTextArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextFilter>;
};


export type QueryTimelineArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTimelineCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TimelineOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TimelineFilter>;
};


export type QueryUrlArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUrlCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<UrlOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UrlFilter>;
};


export type QueryVideoArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<VideoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VideoFilter>;
};

export type ResourceLink = {
  __typename?: 'ResourceLink';
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: 'ResourceSys';
  linkType: Scalars['String'];
  type: Scalars['String'];
  urn: Scalars['String'];
};

/** Structural component - Section, for generic layouts. [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/section) */
export type Section = Entry & {
  __typename?: 'Section';
  bottomButtonsCollection?: Maybe<SectionBottomButtonsCollection>;
  childrenCollection?: Maybe<SectionChildrenCollection>;
  columns?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<SectionLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  sys: Sys;
  text?: Maybe<Text>;
  topButtonsCollection?: Maybe<SectionTopButtonsCollection>;
};


/** Structural component - Section, for generic layouts. [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/section) */
export type SectionBottomButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SectionBottomButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CtaFilter>;
};


/** Structural component - Section, for generic layouts. [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/section) */
export type SectionChildrenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SectionChildrenFilter>;
};


/** Structural component - Section, for generic layouts. [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/section) */
export type SectionColumnsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural component - Section, for generic layouts. [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/section) */
export type SectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Structural component - Section, for generic layouts. [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/section) */
export type SectionNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Structural component - Section, for generic layouts. [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/section) */
export type SectionTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TextFilter>;
};


/** Structural component - Section, for generic layouts. [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/section) */
export type SectionTopButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SectionTopButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CtaFilter>;
};

export type SectionBottomButtonsCollection = {
  __typename?: 'SectionBottomButtonsCollection';
  items: Array<Maybe<Cta>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum SectionBottomButtonsCollectionOrder {
  IconPositionAsc = 'iconPosition_ASC',
  IconPositionDesc = 'iconPosition_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  NewTabAsc = 'newTab_ASC',
  NewTabDesc = 'newTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemplateAsc = 'template_ASC',
  TemplateDesc = 'template_DESC'
}

export type SectionChildrenCollection = {
  __typename?: 'SectionChildrenCollection';
  items: Array<Maybe<SectionChildrenItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SectionChildrenFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionChildrenFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionChildrenFilter>>>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SectionChildrenItem = Card | News;

export type SectionCollection = {
  __typename?: 'SectionCollection';
  items: Array<Maybe<Section>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionFilter>>>;
  bottomButtons?: InputMaybe<CfCtaNestedFilter>;
  bottomButtonsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  children?: InputMaybe<CfchildrenMultiTypeNestedFilter>;
  childrenCollection_exists?: InputMaybe<Scalars['Boolean']>;
  columns?: InputMaybe<Scalars['String']>;
  columns_contains?: InputMaybe<Scalars['String']>;
  columns_exists?: InputMaybe<Scalars['Boolean']>;
  columns_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  columns_not?: InputMaybe<Scalars['String']>;
  columns_not_contains?: InputMaybe<Scalars['String']>;
  columns_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfTextNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  topButtons?: InputMaybe<CfCtaNestedFilter>;
  topButtonsCollection_exists?: InputMaybe<Scalars['Boolean']>;
};

export type SectionLinkingCollections = {
  __typename?: 'SectionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type SectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SectionLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SectionLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SectionLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SectionOrder {
  ColumnsAsc = 'columns_ASC',
  ColumnsDesc = 'columns_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type SectionTopButtonsCollection = {
  __typename?: 'SectionTopButtonsCollection';
  items: Array<Maybe<Cta>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum SectionTopButtonsCollectionOrder {
  IconPositionAsc = 'iconPosition_ASC',
  IconPositionDesc = 'iconPosition_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  NewTabAsc = 'newTab_ASC',
  NewTabDesc = 'newTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemplateAsc = 'template_ASC',
  TemplateDesc = 'template_DESC'
}

/** Robots & Sitemap rules [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/seoSitemapRules) */
export type SeoSitemapRules = Entry & {
  __typename?: 'SeoSitemapRules';
  contentfulMetadata: ContentfulMetadata;
  indexFrequency?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<SeoSitemapRulesLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  robotsNoFollow?: Maybe<Scalars['Boolean']>;
  robotsNoIndex?: Maybe<Scalars['Boolean']>;
  sys: Sys;
};


/** Robots & Sitemap rules [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/seoSitemapRules) */
export type SeoSitemapRulesIndexFrequencyArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Robots & Sitemap rules [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/seoSitemapRules) */
export type SeoSitemapRulesLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Robots & Sitemap rules [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/seoSitemapRules) */
export type SeoSitemapRulesNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Robots & Sitemap rules [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/seoSitemapRules) */
export type SeoSitemapRulesPriorityArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Robots & Sitemap rules [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/seoSitemapRules) */
export type SeoSitemapRulesRobotsNoFollowArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Robots & Sitemap rules [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/seoSitemapRules) */
export type SeoSitemapRulesRobotsNoIndexArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type SeoSitemapRulesCollection = {
  __typename?: 'SeoSitemapRulesCollection';
  items: Array<Maybe<SeoSitemapRules>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SeoSitemapRulesFilter = {
  AND?: InputMaybe<Array<InputMaybe<SeoSitemapRulesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SeoSitemapRulesFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  indexFrequency?: InputMaybe<Scalars['String']>;
  indexFrequency_contains?: InputMaybe<Scalars['String']>;
  indexFrequency_exists?: InputMaybe<Scalars['Boolean']>;
  indexFrequency_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  indexFrequency_not?: InputMaybe<Scalars['String']>;
  indexFrequency_not_contains?: InputMaybe<Scalars['String']>;
  indexFrequency_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priority?: InputMaybe<Scalars['String']>;
  priority_contains?: InputMaybe<Scalars['String']>;
  priority_exists?: InputMaybe<Scalars['Boolean']>;
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priority_not?: InputMaybe<Scalars['String']>;
  priority_not_contains?: InputMaybe<Scalars['String']>;
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  robotsNoFollow?: InputMaybe<Scalars['Boolean']>;
  robotsNoFollow_exists?: InputMaybe<Scalars['Boolean']>;
  robotsNoFollow_not?: InputMaybe<Scalars['Boolean']>;
  robotsNoIndex?: InputMaybe<Scalars['Boolean']>;
  robotsNoIndex_exists?: InputMaybe<Scalars['Boolean']>;
  robotsNoIndex_not?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type SeoSitemapRulesLinkingCollections = {
  __typename?: 'SeoSitemapRulesLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type SeoSitemapRulesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SeoSitemapRulesLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SeoSitemapRulesLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SeoSitemapRulesLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SeoSitemapRulesOrder {
  IndexFrequencyAsc = 'indexFrequency_ASC',
  IndexFrequencyDesc = 'indexFrequency_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PriorityAsc = 'priority_ASC',
  PriorityDesc = 'priority_DESC',
  RobotsNoFollowAsc = 'robotsNoFollow_ASC',
  RobotsNoFollowDesc = 'robotsNoFollow_DESC',
  RobotsNoIndexAsc = 'robotsNoIndex_ASC',
  RobotsNoIndexDesc = 'robotsNoIndex_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedVersion?: Maybe<Scalars['Int']>;
  spaceId: Scalars['String'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** Data for text entry [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/text) */
export type Text = Entry & {
  __typename?: 'Text';
  caption?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TextLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  richText?: Maybe<TextRichText>;
  subtitle?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** Data for text entry [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/text) */
export type TextCaptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for text entry [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/text) */
export type TextDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for text entry [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/text) */
export type TextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Data for text entry [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/text) */
export type TextNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for text entry [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/text) */
export type TextRichTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for text entry [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/text) */
export type TextSubtitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for text entry [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/text) */
export type TextTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type TextCollection = {
  __typename?: 'TextCollection';
  items: Array<Maybe<Text>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TextFilter = {
  AND?: InputMaybe<Array<InputMaybe<TextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TextFilter>>>;
  caption?: InputMaybe<Scalars['String']>;
  caption_contains?: InputMaybe<Scalars['String']>;
  caption_exists?: InputMaybe<Scalars['Boolean']>;
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption_not?: InputMaybe<Scalars['String']>;
  caption_not_contains?: InputMaybe<Scalars['String']>;
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  richText_contains?: InputMaybe<Scalars['String']>;
  richText_exists?: InputMaybe<Scalars['Boolean']>;
  richText_not_contains?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitle_contains?: InputMaybe<Scalars['String']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle_not?: InputMaybe<Scalars['String']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TextLinkingCollections = {
  __typename?: 'TextLinkingCollections';
  cardCollection?: Maybe<CardCollection>;
  carouselCollection?: Maybe<CarouselCollection>;
  entryCollection?: Maybe<EntryCollection>;
  faqCollection?: Maybe<FaqCollection>;
  footerCollection?: Maybe<FooterCollection>;
  galleryItemCollection?: Maybe<GalleryItemCollection>;
  heroSlideCollection?: Maybe<HeroSlideCollection>;
  navigationCollection?: Maybe<NavigationCollection>;
  sectionCollection?: Maybe<SectionCollection>;
};


export type TextLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextLinkingCollectionsCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextLinkingCollectionsCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextLinkingCollectionsFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextLinkingCollectionsFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextLinkingCollectionsFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextLinkingCollectionsFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextLinkingCollectionsGalleryItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextLinkingCollectionsGalleryItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextLinkingCollectionsHeroSlideCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextLinkingCollectionsHeroSlideCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextLinkingCollectionsNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextLinkingCollectionsNavigationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextLinkingCollectionsSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextLinkingCollectionsSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TextLinkingCollectionsCardCollectionOrder {
  CardAspectRatioAsc = 'cardAspectRatio_ASC',
  CardAspectRatioDesc = 'cardAspectRatio_DESC',
  CardLayoutAsc = 'cardLayout_ASC',
  CardLayoutDesc = 'cardLayout_DESC',
  ContentLayoutAsc = 'contentLayout_ASC',
  ContentLayoutDesc = 'contentLayout_DESC',
  ContentSizeAsc = 'contentSize_ASC',
  ContentSizeDesc = 'contentSize_DESC',
  MarginsAsc = 'margins_ASC',
  MarginsDesc = 'margins_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  WidthLimitAsc = 'widthLimit_ASC',
  WidthLimitDesc = 'widthLimit_DESC'
}

export enum TextLinkingCollectionsCarouselCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SpeedAsc = 'speed_ASC',
  SpeedDesc = 'speed_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TextLinkingCollectionsFaqCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TextLinkingCollectionsFooterCollectionOrder {
  FacebookUrlAsc = 'facebookUrl_ASC',
  FacebookUrlDesc = 'facebookUrl_DESC',
  InstagramUrlAsc = 'instagramUrl_ASC',
  InstagramUrlDesc = 'instagramUrl_DESC',
  LinkedInUrlAsc = 'linkedInUrl_ASC',
  LinkedInUrlDesc = 'linkedInUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterUrlAsc = 'twitterUrl_ASC',
  TwitterUrlDesc = 'twitterUrl_DESC'
}

export enum TextLinkingCollectionsGalleryItemCollectionOrder {
  ItemTypeAsc = 'itemType_ASC',
  ItemTypeDesc = 'itemType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TextLinkingCollectionsHeroSlideCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OverlayAssetAsc = 'overlayAsset_ASC',
  OverlayAssetDesc = 'overlayAsset_DESC',
  OverlayCtaLabelAsc = 'overlayCtaLabel_ASC',
  OverlayCtaLabelDesc = 'overlayCtaLabel_DESC',
  SlideAppearanceAsc = 'slideAppearance_ASC',
  SlideAppearanceDesc = 'slideAppearance_DESC',
  SlideTypeAsc = 'slideType_ASC',
  SlideTypeDesc = 'slideType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TextLinkingCollectionsNavigationCollectionOrder {
  FacebookUrlAsc = 'facebookUrl_ASC',
  FacebookUrlDesc = 'facebookUrl_DESC',
  InstagramUrlAsc = 'instagramUrl_ASC',
  InstagramUrlDesc = 'instagramUrl_DESC',
  LinkedInUrlAsc = 'linkedInUrl_ASC',
  LinkedInUrlDesc = 'linkedInUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TwitterUrlAsc = 'twitterUrl_ASC',
  TwitterUrlDesc = 'twitterUrl_DESC'
}

export enum TextLinkingCollectionsSectionCollectionOrder {
  ColumnsAsc = 'columns_ASC',
  ColumnsDesc = 'columns_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TextOrder {
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type TextRichText = {
  __typename?: 'TextRichText';
  json: Scalars['JSON'];
  links: TextRichTextLinks;
};

export type TextRichTextAssets = {
  __typename?: 'TextRichTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TextRichTextEntries = {
  __typename?: 'TextRichTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TextRichTextLinks = {
  __typename?: 'TextRichTextLinks';
  assets: TextRichTextAssets;
  entries: TextRichTextEntries;
  resources: TextRichTextResources;
};

export type TextRichTextResources = {
  __typename?: 'TextRichTextResources';
  block: Array<ResourceLink>;
  hyperlink: Array<ResourceLink>;
  inline: Array<ResourceLink>;
};

/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/timeline) */
export type Timeline = Entry & {
  __typename?: 'Timeline';
  contentfulMetadata: ContentfulMetadata;
  imagesCollection?: Maybe<TimelineImagesCollection>;
  linkedFrom?: Maybe<TimelineLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/timeline) */
export type TimelineImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TimelineImagesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GalleryItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/timeline) */
export type TimelineLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/timeline) */
export type TimelineNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/timeline) */
export type TimelineTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type TimelineCollection = {
  __typename?: 'TimelineCollection';
  items: Array<Maybe<Timeline>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TimelineFilter = {
  AND?: InputMaybe<Array<InputMaybe<TimelineFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TimelineFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  images?: InputMaybe<CfGalleryItemNestedFilter>;
  imagesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TimelineImagesCollection = {
  __typename?: 'TimelineImagesCollection';
  items: Array<Maybe<GalleryItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum TimelineImagesCollectionOrder {
  ItemTypeAsc = 'itemType_ASC',
  ItemTypeDesc = 'itemType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type TimelineLinkingCollections = {
  __typename?: 'TimelineLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type TimelineLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TimelineLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TimelineLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TimelineLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TimelineOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Data for URLs [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/url) */
export type Url = Entry & {
  __typename?: 'Url';
  contactFormRole?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  externalLink?: Maybe<Scalars['String']>;
  internalLink?: Maybe<Page>;
  label?: Maybe<Scalars['String']>;
  linkType?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<UrlLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  queryParameters?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** Data for URLs [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/url) */
export type UrlContactFormRoleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for URLs [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/url) */
export type UrlExternalLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for URLs [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/url) */
export type UrlInternalLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PageFilter>;
};


/** Data for URLs [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/url) */
export type UrlLabelArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for URLs [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/url) */
export type UrlLinkTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for URLs [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/url) */
export type UrlLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Data for URLs [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/url) */
export type UrlNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Data for URLs [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/url) */
export type UrlQueryParametersArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type UrlCollection = {
  __typename?: 'UrlCollection';
  items: Array<Maybe<Url>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type UrlFilter = {
  AND?: InputMaybe<Array<InputMaybe<UrlFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UrlFilter>>>;
  contactFormRole?: InputMaybe<Scalars['String']>;
  contactFormRole_contains?: InputMaybe<Scalars['String']>;
  contactFormRole_exists?: InputMaybe<Scalars['Boolean']>;
  contactFormRole_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contactFormRole_not?: InputMaybe<Scalars['String']>;
  contactFormRole_not_contains?: InputMaybe<Scalars['String']>;
  contactFormRole_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  externalLink?: InputMaybe<Scalars['String']>;
  externalLink_contains?: InputMaybe<Scalars['String']>;
  externalLink_exists?: InputMaybe<Scalars['Boolean']>;
  externalLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink_not?: InputMaybe<Scalars['String']>;
  externalLink_not_contains?: InputMaybe<Scalars['String']>;
  externalLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalLink?: InputMaybe<CfPageNestedFilter>;
  internalLink_exists?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  label_contains?: InputMaybe<Scalars['String']>;
  label_exists?: InputMaybe<Scalars['Boolean']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  label_not?: InputMaybe<Scalars['String']>;
  label_not_contains?: InputMaybe<Scalars['String']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkType?: InputMaybe<Scalars['String']>;
  linkType_contains?: InputMaybe<Scalars['String']>;
  linkType_exists?: InputMaybe<Scalars['Boolean']>;
  linkType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkType_not?: InputMaybe<Scalars['String']>;
  linkType_not_contains?: InputMaybe<Scalars['String']>;
  linkType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  queryParameters?: InputMaybe<Scalars['String']>;
  queryParameters_contains?: InputMaybe<Scalars['String']>;
  queryParameters_exists?: InputMaybe<Scalars['Boolean']>;
  queryParameters_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  queryParameters_not?: InputMaybe<Scalars['String']>;
  queryParameters_not_contains?: InputMaybe<Scalars['String']>;
  queryParameters_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type UrlLinkingCollections = {
  __typename?: 'UrlLinkingCollections';
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  footerCollection?: Maybe<FooterCollection>;
  navigationCollection?: Maybe<NavigationCollection>;
  newsCollection?: Maybe<NewsCollection>;
};


export type UrlLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<UrlLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type UrlLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type UrlLinkingCollectionsFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<UrlLinkingCollectionsFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type UrlLinkingCollectionsNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<UrlLinkingCollectionsNavigationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type UrlLinkingCollectionsNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<UrlLinkingCollectionsNewsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum UrlLinkingCollectionsCtaCollectionOrder {
  IconPositionAsc = 'iconPosition_ASC',
  IconPositionDesc = 'iconPosition_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  NewTabAsc = 'newTab_ASC',
  NewTabDesc = 'newTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TemplateAsc = 'template_ASC',
  TemplateDesc = 'template_DESC'
}

export enum UrlLinkingCollectionsFooterCollectionOrder {
  FacebookUrlAsc = 'facebookUrl_ASC',
  FacebookUrlDesc = 'facebookUrl_DESC',
  InstagramUrlAsc = 'instagramUrl_ASC',
  InstagramUrlDesc = 'instagramUrl_DESC',
  LinkedInUrlAsc = 'linkedInUrl_ASC',
  LinkedInUrlDesc = 'linkedInUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterUrlAsc = 'twitterUrl_ASC',
  TwitterUrlDesc = 'twitterUrl_DESC'
}

export enum UrlLinkingCollectionsNavigationCollectionOrder {
  FacebookUrlAsc = 'facebookUrl_ASC',
  FacebookUrlDesc = 'facebookUrl_DESC',
  InstagramUrlAsc = 'instagramUrl_ASC',
  InstagramUrlDesc = 'instagramUrl_DESC',
  LinkedInUrlAsc = 'linkedInUrl_ASC',
  LinkedInUrlDesc = 'linkedInUrl_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TwitterUrlAsc = 'twitterUrl_ASC',
  TwitterUrlDesc = 'twitterUrl_DESC'
}

export enum UrlLinkingCollectionsNewsCollectionOrder {
  AssetOverlayAsc = 'assetOverlay_ASC',
  AssetOverlayDesc = 'assetOverlay_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum UrlOrder {
  ContactFormRoleAsc = 'contactFormRole_ASC',
  ContactFormRoleDesc = 'contactFormRole_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LinkTypeAsc = 'linkType_ASC',
  LinkTypeDesc = 'linkType_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QueryParametersAsc = 'queryParameters_ASC',
  QueryParametersDesc = 'queryParameters_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Video Block renders an embedded vimeo video [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/video) */
export type Video = Entry & {
  __typename?: 'Video';
  autoplay?: Maybe<Scalars['Boolean']>;
  contentfulMetadata: ContentfulMetadata;
  controls?: Maybe<Scalars['Boolean']>;
  duration?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<VideoLinkingCollections>;
  loop?: Maybe<Scalars['Boolean']>;
  muted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  posterCollection?: Maybe<VideoPosterCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  vimeoUrl?: Maybe<Scalars['String']>;
};


/** Video Block renders an embedded vimeo video [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/video) */
export type VideoAutoplayArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Video Block renders an embedded vimeo video [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/video) */
export type VideoControlsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Video Block renders an embedded vimeo video [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/video) */
export type VideoDurationArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Video Block renders an embedded vimeo video [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/video) */
export type VideoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Video Block renders an embedded vimeo video [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/video) */
export type VideoLoopArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Video Block renders an embedded vimeo video [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/video) */
export type VideoMutedArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Video Block renders an embedded vimeo video [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/video) */
export type VideoNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Video Block renders an embedded vimeo video [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/video) */
export type VideoPosterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<VideoPosterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentTypeAssetFilter>;
};


/** Video Block renders an embedded vimeo video [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/video) */
export type VideoTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Video Block renders an embedded vimeo video [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/video) */
export type VideoTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Video Block renders an embedded vimeo video [See type definition](https://app.contentful.com/spaces/008uhrl7fe4e/content_types/video) */
export type VideoVimeoUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type VideoCollection = {
  __typename?: 'VideoCollection';
  items: Array<Maybe<Video>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type VideoFilter = {
  AND?: InputMaybe<Array<InputMaybe<VideoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VideoFilter>>>;
  autoplay?: InputMaybe<Scalars['Boolean']>;
  autoplay_exists?: InputMaybe<Scalars['Boolean']>;
  autoplay_not?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  controls?: InputMaybe<Scalars['Boolean']>;
  controls_exists?: InputMaybe<Scalars['Boolean']>;
  controls_not?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['String']>;
  duration_contains?: InputMaybe<Scalars['String']>;
  duration_exists?: InputMaybe<Scalars['Boolean']>;
  duration_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  duration_not?: InputMaybe<Scalars['String']>;
  duration_not_contains?: InputMaybe<Scalars['String']>;
  duration_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  loop?: InputMaybe<Scalars['Boolean']>;
  loop_exists?: InputMaybe<Scalars['Boolean']>;
  loop_not?: InputMaybe<Scalars['Boolean']>;
  muted?: InputMaybe<Scalars['Boolean']>;
  muted_exists?: InputMaybe<Scalars['Boolean']>;
  muted_not?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poster?: InputMaybe<CfContentTypeAssetNestedFilter>;
  posterCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vimeoUrl?: InputMaybe<Scalars['String']>;
  vimeoUrl_contains?: InputMaybe<Scalars['String']>;
  vimeoUrl_exists?: InputMaybe<Scalars['Boolean']>;
  vimeoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vimeoUrl_not?: InputMaybe<Scalars['String']>;
  vimeoUrl_not_contains?: InputMaybe<Scalars['String']>;
  vimeoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VideoLinkingCollections = {
  __typename?: 'VideoLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type VideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type VideoLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum VideoLinkingCollectionsPageCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PageTypeAsc = 'pageType_ASC',
  PageTypeDesc = 'pageType_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VideoOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  ControlsAsc = 'controls_ASC',
  ControlsDesc = 'controls_DESC',
  DurationAsc = 'duration_ASC',
  DurationDesc = 'duration_DESC',
  LoopAsc = 'loop_ASC',
  LoopDesc = 'loop_DESC',
  MutedAsc = 'muted_ASC',
  MutedDesc = 'muted_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  VimeoUrlAsc = 'vimeoUrl_ASC',
  VimeoUrlDesc = 'vimeoUrl_DESC'
}

export type VideoPosterCollection = {
  __typename?: 'VideoPosterCollection';
  items: Array<Maybe<ContentTypeAsset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum VideoPosterCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  ControlsAsc = 'controls_ASC',
  ControlsDesc = 'controls_DESC',
  ImageUrlAsc = 'imageUrl_ASC',
  ImageUrlDesc = 'imageUrl_DESC',
  LoopAsc = 'loop_ASC',
  LoopDesc = 'loop_DESC',
  MutedAsc = 'muted_ASC',
  MutedDesc = 'muted_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VideoResolutionAsc = 'videoResolution_ASC',
  VideoResolutionDesc = 'videoResolution_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type _Node = {
  _id: Scalars['ID'];
};

export type CfCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCardNestedFilter>>>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  backgroundAsset_exists?: InputMaybe<Scalars['Boolean']>;
  cardAspectRatio?: InputMaybe<Scalars['String']>;
  cardAspectRatio_contains?: InputMaybe<Scalars['String']>;
  cardAspectRatio_exists?: InputMaybe<Scalars['Boolean']>;
  cardAspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cardAspectRatio_not?: InputMaybe<Scalars['String']>;
  cardAspectRatio_not_contains?: InputMaybe<Scalars['String']>;
  cardAspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cardLayout?: InputMaybe<Scalars['String']>;
  cardLayout_contains?: InputMaybe<Scalars['String']>;
  cardLayout_exists?: InputMaybe<Scalars['Boolean']>;
  cardLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cardLayout_not?: InputMaybe<Scalars['String']>;
  cardLayout_not_contains?: InputMaybe<Scalars['String']>;
  cardLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentLayout?: InputMaybe<Scalars['String']>;
  contentLayout_contains?: InputMaybe<Scalars['String']>;
  contentLayout_exists?: InputMaybe<Scalars['Boolean']>;
  contentLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentLayout_not?: InputMaybe<Scalars['String']>;
  contentLayout_not_contains?: InputMaybe<Scalars['String']>;
  contentLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentSize?: InputMaybe<Scalars['String']>;
  contentSize_contains?: InputMaybe<Scalars['String']>;
  contentSize_exists?: InputMaybe<Scalars['Boolean']>;
  contentSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentSize_not?: InputMaybe<Scalars['String']>;
  contentSize_not_contains?: InputMaybe<Scalars['String']>;
  contentSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaCollection_exists?: InputMaybe<Scalars['Boolean']>;
  link_exists?: InputMaybe<Scalars['Boolean']>;
  margins?: InputMaybe<Scalars['Boolean']>;
  margins_exists?: InputMaybe<Scalars['Boolean']>;
  margins_not?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  widthLimit?: InputMaybe<Scalars['Boolean']>;
  widthLimit_exists?: InputMaybe<Scalars['Boolean']>;
  widthLimit_not?: InputMaybe<Scalars['Boolean']>;
};

export type CfContentTypeAssetNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfContentTypeAssetNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfContentTypeAssetNestedFilter>>>;
  animationData_exists?: InputMaybe<Scalars['Boolean']>;
  autoplay?: InputMaybe<Scalars['Boolean']>;
  autoplay_exists?: InputMaybe<Scalars['Boolean']>;
  autoplay_not?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  context_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  context_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  context_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  context_exists?: InputMaybe<Scalars['Boolean']>;
  controls?: InputMaybe<Scalars['Boolean']>;
  controls_exists?: InputMaybe<Scalars['Boolean']>;
  controls_not?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  imageUrl_contains?: InputMaybe<Scalars['String']>;
  imageUrl_exists?: InputMaybe<Scalars['Boolean']>;
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageUrl_not?: InputMaybe<Scalars['String']>;
  imageUrl_not_contains?: InputMaybe<Scalars['String']>;
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  loop?: InputMaybe<Scalars['Boolean']>;
  loop_exists?: InputMaybe<Scalars['Boolean']>;
  loop_not?: InputMaybe<Scalars['Boolean']>;
  muted?: InputMaybe<Scalars['Boolean']>;
  muted_exists?: InputMaybe<Scalars['Boolean']>;
  muted_not?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sizes_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sizes_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sizes_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sizes_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  videoResolution?: InputMaybe<Scalars['String']>;
  videoResolution_contains?: InputMaybe<Scalars['String']>;
  videoResolution_exists?: InputMaybe<Scalars['Boolean']>;
  videoResolution_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoResolution_not?: InputMaybe<Scalars['String']>;
  videoResolution_not_contains?: InputMaybe<Scalars['String']>;
  videoResolution_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoUrl?: InputMaybe<Scalars['String']>;
  videoUrl_contains?: InputMaybe<Scalars['String']>;
  videoUrl_exists?: InputMaybe<Scalars['Boolean']>;
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoUrl_not?: InputMaybe<Scalars['String']>;
  videoUrl_not_contains?: InputMaybe<Scalars['String']>;
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  video_exists?: InputMaybe<Scalars['Boolean']>;
};

export type CfCtaNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCtaNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCtaNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']>;
  iconPosition?: InputMaybe<Scalars['String']>;
  iconPosition_contains?: InputMaybe<Scalars['String']>;
  iconPosition_exists?: InputMaybe<Scalars['Boolean']>;
  iconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  iconPosition_not?: InputMaybe<Scalars['String']>;
  iconPosition_not_contains?: InputMaybe<Scalars['String']>;
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_contains?: InputMaybe<Scalars['String']>;
  icon_exists?: InputMaybe<Scalars['Boolean']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_not?: InputMaybe<Scalars['String']>;
  icon_not_contains?: InputMaybe<Scalars['String']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newTab?: InputMaybe<Scalars['Boolean']>;
  newTab_exists?: InputMaybe<Scalars['Boolean']>;
  newTab_not?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  template?: InputMaybe<Scalars['String']>;
  template_contains?: InputMaybe<Scalars['String']>;
  template_exists?: InputMaybe<Scalars['Boolean']>;
  template_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  template_not?: InputMaybe<Scalars['String']>;
  template_not_contains?: InputMaybe<Scalars['String']>;
  template_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
};

export type CfFooterAddressNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfFooterAddressNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfFooterAddressNestedFilter>>>;
  addressFormat?: InputMaybe<Scalars['String']>;
  addressFormat_contains?: InputMaybe<Scalars['String']>;
  addressFormat_exists?: InputMaybe<Scalars['Boolean']>;
  addressFormat_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressFormat_not?: InputMaybe<Scalars['String']>;
  addressFormat_not_contains?: InputMaybe<Scalars['String']>;
  addressFormat_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  office_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfGalleryItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfGalleryItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfGalleryItemNestedFilter>>>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  itemType?: InputMaybe<Scalars['String']>;
  itemType_contains?: InputMaybe<Scalars['String']>;
  itemType_exists?: InputMaybe<Scalars['Boolean']>;
  itemType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  itemType_not?: InputMaybe<Scalars['String']>;
  itemType_not_contains?: InputMaybe<Scalars['String']>;
  itemType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
};

export type CfHeroSlideNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeroSlideNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeroSlideNestedFilter>>>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overlayAsset?: InputMaybe<Scalars['String']>;
  overlayAsset_contains?: InputMaybe<Scalars['String']>;
  overlayAsset_exists?: InputMaybe<Scalars['Boolean']>;
  overlayAsset_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overlayAsset_not?: InputMaybe<Scalars['String']>;
  overlayAsset_not_contains?: InputMaybe<Scalars['String']>;
  overlayAsset_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overlayButtonsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  overlayCtaLabel?: InputMaybe<Scalars['String']>;
  overlayCtaLabel_contains?: InputMaybe<Scalars['String']>;
  overlayCtaLabel_exists?: InputMaybe<Scalars['Boolean']>;
  overlayCtaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overlayCtaLabel_not?: InputMaybe<Scalars['String']>;
  overlayCtaLabel_not_contains?: InputMaybe<Scalars['String']>;
  overlayCtaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overlayText_exists?: InputMaybe<Scalars['Boolean']>;
  slideAppearance?: InputMaybe<Scalars['String']>;
  slideAppearance_contains?: InputMaybe<Scalars['String']>;
  slideAppearance_exists?: InputMaybe<Scalars['Boolean']>;
  slideAppearance_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slideAppearance_not?: InputMaybe<Scalars['String']>;
  slideAppearance_not_contains?: InputMaybe<Scalars['String']>;
  slideAppearance_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slideTextCollection_exists?: InputMaybe<Scalars['Boolean']>;
  slideType?: InputMaybe<Scalars['String']>;
  slideType_contains?: InputMaybe<Scalars['String']>;
  slideType_exists?: InputMaybe<Scalars['Boolean']>;
  slideType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slideType_not?: InputMaybe<Scalars['String']>;
  slideType_not_contains?: InputMaybe<Scalars['String']>;
  slideType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfMetaDataNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMetaDataNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMetaDataNestedFilter>>>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  context_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  context_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  context_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  context_exists?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfNewsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNewsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNewsNestedFilter>>>;
  article_contains?: InputMaybe<Scalars['String']>;
  article_exists?: InputMaybe<Scalars['Boolean']>;
  article_not_contains?: InputMaybe<Scalars['String']>;
  assetOverlay?: InputMaybe<Scalars['String']>;
  assetOverlay_contains?: InputMaybe<Scalars['String']>;
  assetOverlay_exists?: InputMaybe<Scalars['Boolean']>;
  assetOverlay_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  assetOverlay_not?: InputMaybe<Scalars['String']>;
  assetOverlay_not_contains?: InputMaybe<Scalars['String']>;
  assetOverlay_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  date?: InputMaybe<Scalars['DateTime']>;
  date_exists?: InputMaybe<Scalars['Boolean']>;
  date_gt?: InputMaybe<Scalars['DateTime']>;
  date_gte?: InputMaybe<Scalars['DateTime']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  date_lt?: InputMaybe<Scalars['DateTime']>;
  date_lte?: InputMaybe<Scalars['DateTime']>;
  date_not?: InputMaybe<Scalars['DateTime']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organizationLogo_exists?: InputMaybe<Scalars['Boolean']>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitle_contains?: InputMaybe<Scalars['String']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle_not?: InputMaybe<Scalars['String']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
};

export type CfOfficeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfOfficeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfOfficeNestedFilter>>>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressCountry_contains?: InputMaybe<Scalars['String']>;
  addressCountry_exists?: InputMaybe<Scalars['Boolean']>;
  addressCountry_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressCountry_not?: InputMaybe<Scalars['String']>;
  addressCountry_not_contains?: InputMaybe<Scalars['String']>;
  addressCountry_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressLocality?: InputMaybe<Scalars['String']>;
  addressLocality_contains?: InputMaybe<Scalars['String']>;
  addressLocality_exists?: InputMaybe<Scalars['Boolean']>;
  addressLocality_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressLocality_not?: InputMaybe<Scalars['String']>;
  addressLocality_not_contains?: InputMaybe<Scalars['String']>;
  addressLocality_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressRegion?: InputMaybe<Scalars['String']>;
  addressRegion_contains?: InputMaybe<Scalars['String']>;
  addressRegion_exists?: InputMaybe<Scalars['Boolean']>;
  addressRegion_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressRegion_not?: InputMaybe<Scalars['String']>;
  addressRegion_not_contains?: InputMaybe<Scalars['String']>;
  addressRegion_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  email?: InputMaybe<Scalars['String']>;
  email_contains?: InputMaybe<Scalars['String']>;
  email_exists?: InputMaybe<Scalars['Boolean']>;
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email_not?: InputMaybe<Scalars['String']>;
  email_not_contains?: InputMaybe<Scalars['String']>;
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleMapsLink?: InputMaybe<Scalars['String']>;
  googleMapsLink_contains?: InputMaybe<Scalars['String']>;
  googleMapsLink_exists?: InputMaybe<Scalars['Boolean']>;
  googleMapsLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  googleMapsLink_not?: InputMaybe<Scalars['String']>;
  googleMapsLink_not_contains?: InputMaybe<Scalars['String']>;
  googleMapsLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phone?: InputMaybe<Scalars['String']>;
  phone_contains?: InputMaybe<Scalars['String']>;
  phone_exists?: InputMaybe<Scalars['Boolean']>;
  phone_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phone_not?: InputMaybe<Scalars['String']>;
  phone_not_contains?: InputMaybe<Scalars['String']>;
  phone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  postalCode?: InputMaybe<Scalars['String']>;
  postalCode_contains?: InputMaybe<Scalars['String']>;
  postalCode_exists?: InputMaybe<Scalars['Boolean']>;
  postalCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  postalCode_not?: InputMaybe<Scalars['String']>;
  postalCode_not_contains?: InputMaybe<Scalars['String']>;
  postalCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddressLine1?: InputMaybe<Scalars['String']>;
  streetAddressLine1_contains?: InputMaybe<Scalars['String']>;
  streetAddressLine1_exists?: InputMaybe<Scalars['Boolean']>;
  streetAddressLine1_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddressLine1_not?: InputMaybe<Scalars['String']>;
  streetAddressLine1_not_contains?: InputMaybe<Scalars['String']>;
  streetAddressLine1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddressLine2?: InputMaybe<Scalars['String']>;
  streetAddressLine2_contains?: InputMaybe<Scalars['String']>;
  streetAddressLine2_exists?: InputMaybe<Scalars['Boolean']>;
  streetAddressLine2_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  streetAddressLine2_not?: InputMaybe<Scalars['String']>;
  streetAddressLine2_not_contains?: InputMaybe<Scalars['String']>;
  streetAddressLine2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ukCompanyNumber?: InputMaybe<Scalars['String']>;
  ukCompanyNumber_contains?: InputMaybe<Scalars['String']>;
  ukCompanyNumber_exists?: InputMaybe<Scalars['Boolean']>;
  ukCompanyNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ukCompanyNumber_not?: InputMaybe<Scalars['String']>;
  ukCompanyNumber_not_contains?: InputMaybe<Scalars['String']>;
  ukCompanyNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfPageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPageNestedFilter>>>;
  contentCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  country_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country_exists?: InputMaybe<Scalars['Boolean']>;
  language_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language_exists?: InputMaybe<Scalars['Boolean']>;
  metaDataCollection_exists?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageType?: InputMaybe<Scalars['String']>;
  pageType_contains?: InputMaybe<Scalars['String']>;
  pageType_exists?: InputMaybe<Scalars['Boolean']>;
  pageType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageType_not?: InputMaybe<Scalars['String']>;
  pageType_not_contains?: InputMaybe<Scalars['String']>;
  pageType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentPage_exists?: InputMaybe<Scalars['Boolean']>;
  robots_exists?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structuredDataCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfSeoSitemapRulesNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSeoSitemapRulesNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSeoSitemapRulesNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  indexFrequency?: InputMaybe<Scalars['String']>;
  indexFrequency_contains?: InputMaybe<Scalars['String']>;
  indexFrequency_exists?: InputMaybe<Scalars['Boolean']>;
  indexFrequency_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  indexFrequency_not?: InputMaybe<Scalars['String']>;
  indexFrequency_not_contains?: InputMaybe<Scalars['String']>;
  indexFrequency_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priority?: InputMaybe<Scalars['String']>;
  priority_contains?: InputMaybe<Scalars['String']>;
  priority_exists?: InputMaybe<Scalars['Boolean']>;
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priority_not?: InputMaybe<Scalars['String']>;
  priority_not_contains?: InputMaybe<Scalars['String']>;
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  robotsNoFollow?: InputMaybe<Scalars['Boolean']>;
  robotsNoFollow_exists?: InputMaybe<Scalars['Boolean']>;
  robotsNoFollow_not?: InputMaybe<Scalars['Boolean']>;
  robotsNoIndex?: InputMaybe<Scalars['Boolean']>;
  robotsNoIndex_exists?: InputMaybe<Scalars['Boolean']>;
  robotsNoIndex_not?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTextNestedFilter>>>;
  caption?: InputMaybe<Scalars['String']>;
  caption_contains?: InputMaybe<Scalars['String']>;
  caption_exists?: InputMaybe<Scalars['Boolean']>;
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  caption_not?: InputMaybe<Scalars['String']>;
  caption_not_contains?: InputMaybe<Scalars['String']>;
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  richText_contains?: InputMaybe<Scalars['String']>;
  richText_exists?: InputMaybe<Scalars['Boolean']>;
  richText_not_contains?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  subtitle_contains?: InputMaybe<Scalars['String']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subtitle_not?: InputMaybe<Scalars['String']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfUrlNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfUrlNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfUrlNestedFilter>>>;
  contactFormRole?: InputMaybe<Scalars['String']>;
  contactFormRole_contains?: InputMaybe<Scalars['String']>;
  contactFormRole_exists?: InputMaybe<Scalars['Boolean']>;
  contactFormRole_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contactFormRole_not?: InputMaybe<Scalars['String']>;
  contactFormRole_not_contains?: InputMaybe<Scalars['String']>;
  contactFormRole_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  externalLink?: InputMaybe<Scalars['String']>;
  externalLink_contains?: InputMaybe<Scalars['String']>;
  externalLink_exists?: InputMaybe<Scalars['Boolean']>;
  externalLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink_not?: InputMaybe<Scalars['String']>;
  externalLink_not_contains?: InputMaybe<Scalars['String']>;
  externalLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalLink_exists?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  label_contains?: InputMaybe<Scalars['String']>;
  label_exists?: InputMaybe<Scalars['Boolean']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  label_not?: InputMaybe<Scalars['String']>;
  label_not_contains?: InputMaybe<Scalars['String']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkType?: InputMaybe<Scalars['String']>;
  linkType_contains?: InputMaybe<Scalars['String']>;
  linkType_exists?: InputMaybe<Scalars['Boolean']>;
  linkType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkType_not?: InputMaybe<Scalars['String']>;
  linkType_not_contains?: InputMaybe<Scalars['String']>;
  linkType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  queryParameters?: InputMaybe<Scalars['String']>;
  queryParameters_contains?: InputMaybe<Scalars['String']>;
  queryParameters_exists?: InputMaybe<Scalars['Boolean']>;
  queryParameters_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  queryParameters_not?: InputMaybe<Scalars['String']>;
  queryParameters_not_contains?: InputMaybe<Scalars['String']>;
  queryParameters_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfchildrenMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfchildrenMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfchildrenMultiTypeNestedFilter>>>;
  assetsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfcontentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcontentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcontentMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CardFragment = (
  { __typename?: 'Card', name?: string | null, contentLayout?: string | null, cardLayout?: string | null, cardAspectRatio?: string | null, type?: string | null, margins?: boolean | null, contentSize?: string | null, widthLimit?: boolean | null, text?: (
    { __typename?: 'Text' }
    & { ' $fragmentRefs'?: { 'TextFragment': TextFragment } }
  ) | null, ctaCollection?: { __typename?: 'CardCtaCollection', total: number, items: Array<(
      { __typename?: 'Cta' }
      & { ' $fragmentRefs'?: { 'CtaFragment': CtaFragment } }
    ) | null> } | null, assetsCollection?: { __typename?: 'CardAssetsCollection', total: number, items: Array<(
      { __typename?: 'ContentTypeAsset' }
      & { ' $fragmentRefs'?: { 'TypeAssetFragment': TypeAssetFragment } }
    ) | null> } | null, backgroundAsset?: (
    { __typename?: 'ContentTypeAsset' }
    & { ' $fragmentRefs'?: { 'TypeAssetFragment': TypeAssetFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'Sys_Card_Fragment': Sys_Card_Fragment } }
) & { ' $fragmentName'?: 'CardFragment' };

export type CarouselFragment = (
  { __typename?: 'Carousel', name?: string | null, speed?: number | null, text?: (
    { __typename?: 'Text' }
    & { ' $fragmentRefs'?: { 'TextFragment': TextFragment } }
  ) | null, slidesCollection?: { __typename?: 'CarouselSlidesCollection', total: number, items: Array<(
      { __typename?: 'Card' }
      & { ' $fragmentRefs'?: { 'CardFragment': CardFragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'Sys_Carousel_Fragment': Sys_Carousel_Fragment } }
) & { ' $fragmentName'?: 'CarouselFragment' };

export type FaqFragment = (
  { __typename?: 'Faq', name?: string | null, questionsCollection?: { __typename?: 'FaqQuestionsCollection', total: number, items: Array<(
      { __typename?: 'Text' }
      & { ' $fragmentRefs'?: { 'TextFragment': TextFragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'Sys_Faq_Fragment': Sys_Faq_Fragment } }
) & { ' $fragmentName'?: 'FaqFragment' };

export type FooterAddressFragment = (
  { __typename?: 'FooterAddress', addressFormat?: string | null, office?: (
    { __typename?: 'Office' }
    & { ' $fragmentRefs'?: { 'OfficeFragment': OfficeFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'Sys_FooterAddress_Fragment': Sys_FooterAddress_Fragment } }
) & { ' $fragmentName'?: 'FooterAddressFragment' };

export type FooterQueryVariables = Exact<{
  language?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type FooterQuery = { __typename?: 'Query', footerCollection?: { __typename?: 'FooterCollection', total: number, items: Array<(
      { __typename?: 'Footer', title?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, twitterUrl?: string | null, copyright?: (
        { __typename?: 'Text' }
        & { ' $fragmentRefs'?: { 'TextFragment': TextFragment } }
      ) | null, primaryLinksCollection?: { __typename?: 'FooterPrimaryLinksCollection', total: number, items: Array<(
          { __typename?: 'Url' }
          & { ' $fragmentRefs'?: { 'PageUrl_Url_Fragment': PageUrl_Url_Fragment } }
        ) | null> } | null, secondaryLinksCollection?: { __typename?: 'FooterSecondaryLinksCollection', total: number, items: Array<(
          { __typename?: 'Url' }
          & { ' $fragmentRefs'?: { 'PageUrl_Url_Fragment': PageUrl_Url_Fragment } }
        ) | null> } | null, addressesCollection?: { __typename?: 'FooterAddressesCollection', total: number, items: Array<(
          { __typename?: 'FooterAddress' }
          & { ' $fragmentRefs'?: { 'FooterAddressFragment': FooterAddressFragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'Sys_Footer_Fragment': Sys_Footer_Fragment } }
    ) | null> } | null };

export type GalleryFragment = (
  { __typename?: 'Gallery', name?: string | null, speed?: number | null, imagesCollection?: { __typename?: 'GalleryImagesCollection', total: number, items: Array<(
      { __typename?: 'GalleryItem' }
      & { ' $fragmentRefs'?: { 'GalleryItemFragment': GalleryItemFragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'Sys_Gallery_Fragment': Sys_Gallery_Fragment } }
) & { ' $fragmentName'?: 'GalleryFragment' };

export type HtmlFragment = (
  { __typename?: 'Html', name?: string | null, html?: string | null }
  & { ' $fragmentRefs'?: { 'Sys_Html_Fragment': Sys_Html_Fragment } }
) & { ' $fragmentName'?: 'HtmlFragment' };

export type HeroFragment = (
  { __typename?: 'Hero', name?: string | null, heroType?: string | null, scrollCtaLabel?: string | null, slidesCollection?: { __typename?: 'HeroSlidesCollection', total: number, items: Array<(
      { __typename?: 'HeroSlide' }
      & { ' $fragmentRefs'?: { 'HeroSlideFragment': HeroSlideFragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'Sys_Hero_Fragment': Sys_Hero_Fragment } }
) & { ' $fragmentName'?: 'HeroFragment' };

export type HeroSlideFragment = (
  { __typename?: 'HeroSlide', name?: string | null, slideType?: string | null, overlayCtaLabel?: string | null, overlayAsset?: string | null, slideAppearance?: string | null, assetsCollection?: { __typename?: 'HeroSlideAssetsCollection', total: number, items: Array<(
      { __typename?: 'ContentTypeAsset' }
      & { ' $fragmentRefs'?: { 'TypeAssetFragment': TypeAssetFragment } }
    ) | null> } | null, slideTextCollection?: { __typename?: 'HeroSlideSlideTextCollection', total: number, items: Array<(
      { __typename?: 'Text' }
      & { ' $fragmentRefs'?: { 'TextFragment': TextFragment } }
    ) | null> } | null, overlayText?: (
    { __typename?: 'Text' }
    & { ' $fragmentRefs'?: { 'TextFragment': TextFragment } }
  ) | null, overlayButtonsCollection?: { __typename?: 'HeroSlideOverlayButtonsCollection', total: number, items: Array<(
      { __typename?: 'Cta' }
      & { ' $fragmentRefs'?: { 'CtaFragment': CtaFragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'Sys_HeroSlide_Fragment': Sys_HeroSlide_Fragment } }
) & { ' $fragmentName'?: 'HeroSlideFragment' };

export type ListFragment = (
  { __typename?: 'List', type?: string | null }
  & { ' $fragmentRefs'?: { 'Sys_List_Fragment': Sys_List_Fragment } }
) & { ' $fragmentName'?: 'ListFragment' };

export type PageMetaQueryVariables = Exact<{
  language?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type PageMetaQuery = { __typename?: 'Query', page?: (
    { __typename?: 'Page', robots?: (
      { __typename?: 'SeoSitemapRules' }
      & { ' $fragmentRefs'?: { 'SeoFragment': SeoFragment } }
    ) | null, metaDataCollection?: { __typename?: 'PageMetaDataCollection', total: number, items: Array<(
        { __typename?: 'MetaData' }
        & { ' $fragmentRefs'?: { 'MetaDataFragment': MetaDataFragment } }
      ) | null> } | null }
    & { ' $fragmentRefs'?: { 'PathSegmentFragment': PathSegmentFragment } }
  ) | null };

export type PageMetaGlobalQueryVariables = Exact<{
  language?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
}>;


export type PageMetaGlobalQuery = { __typename?: 'Query', metaDataCollection?: { __typename?: 'MetaDataCollection', total: number, items: Array<(
      { __typename?: 'MetaData' }
      & { ' $fragmentRefs'?: { 'MetaDataFragment': MetaDataFragment } }
    ) | null> } | null };

export type NavigationQueryVariables = Exact<{
  language?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type NavigationQuery = { __typename?: 'Query', navigationCollection?: { __typename?: 'NavigationCollection', total: number, items: Array<(
      { __typename?: 'Navigation', facebookUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null, twitterUrl?: string | null, primaryLinksCollection?: { __typename?: 'NavigationPrimaryLinksCollection', total: number, items: Array<(
          { __typename?: 'Url' }
          & { ' $fragmentRefs'?: { 'PageUrl_Url_Fragment': PageUrl_Url_Fragment } }
        ) | null> } | null, secondaryLinksCollection?: { __typename?: 'NavigationSecondaryLinksCollection', total: number, items: Array<(
          { __typename?: 'Url' }
          & { ' $fragmentRefs'?: { 'PageUrl_Url_Fragment': PageUrl_Url_Fragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'Sys_Navigation_Fragment': Sys_Navigation_Fragment } }
    ) | null> } | null };

export type NextPrevNewsQueryQueryVariables = Exact<{
  language?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type NextPrevNewsQueryQuery = { __typename?: 'Query', prevNewsItem?: { __typename?: 'NewsCollection', total: number, items: Array<(
      { __typename?: 'News' }
      & { ' $fragmentRefs'?: { 'NewsFragment': NewsFragment } }
    ) | null> } | null, nextNewsItem?: { __typename?: 'NewsCollection', total: number, items: Array<(
      { __typename?: 'News' }
      & { ' $fragmentRefs'?: { 'NewsFragment': NewsFragment } }
    ) | null> } | null };

export type NewsArticlePageQueryQueryVariables = Exact<{
  language?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type NewsArticlePageQueryQuery = { __typename?: 'Query', newsCollection?: { __typename?: 'NewsCollection', total: number, items: Array<{ __typename?: 'News', article?: (
        { __typename?: 'NewsArticle' }
        & { ' $fragmentRefs'?: { 'NewsArticleRichTextFragment': NewsArticleRichTextFragment } }
      ) | null } | null> } | null };

export type PageRecordQueryVariables = Exact<{
  id: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type PageRecordQuery = { __typename?: 'Query', page?: (
    { __typename?: 'Page' }
    & { ' $fragmentRefs'?: { 'PathSegmentFragment': PathSegmentFragment } }
  ) | null };

export type PageRecordContentQueryVariables = Exact<{
  skip?: Scalars['Int'];
  limit?: Scalars['Int'];
  language?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type PageRecordContentQuery = { __typename?: 'Query', page?: { __typename?: 'Page', contentCollection?: { __typename?: 'PageContentCollection', total: number, items: Array<(
        { __typename?: 'Card' }
        & { ' $fragmentRefs'?: { 'PageContentItem_Card_Fragment': PageContentItem_Card_Fragment } }
      ) | (
        { __typename?: 'Carousel' }
        & { ' $fragmentRefs'?: { 'PageContentItem_Carousel_Fragment': PageContentItem_Carousel_Fragment } }
      ) | (
        { __typename?: 'Faq' }
        & { ' $fragmentRefs'?: { 'PageContentItem_Faq_Fragment': PageContentItem_Faq_Fragment } }
      ) | (
        { __typename?: 'Footer' }
        & { ' $fragmentRefs'?: { 'PageContentItem_Footer_Fragment': PageContentItem_Footer_Fragment } }
      ) | (
        { __typename?: 'Gallery' }
        & { ' $fragmentRefs'?: { 'PageContentItem_Gallery_Fragment': PageContentItem_Gallery_Fragment } }
      ) | (
        { __typename?: 'Hero' }
        & { ' $fragmentRefs'?: { 'PageContentItem_Hero_Fragment': PageContentItem_Hero_Fragment } }
      ) | (
        { __typename?: 'Html' }
        & { ' $fragmentRefs'?: { 'PageContentItem_Html_Fragment': PageContentItem_Html_Fragment } }
      ) | (
        { __typename?: 'List' }
        & { ' $fragmentRefs'?: { 'PageContentItem_List_Fragment': PageContentItem_List_Fragment } }
      ) | (
        { __typename?: 'Media' }
        & { ' $fragmentRefs'?: { 'PageContentItem_Media_Fragment': PageContentItem_Media_Fragment } }
      ) | (
        { __typename?: 'Section' }
        & { ' $fragmentRefs'?: { 'PageContentItem_Section_Fragment': PageContentItem_Section_Fragment } }
      ) | (
        { __typename?: 'Timeline' }
        & { ' $fragmentRefs'?: { 'PageContentItem_Timeline_Fragment': PageContentItem_Timeline_Fragment } }
      ) | (
        { __typename?: 'Video' }
        & { ' $fragmentRefs'?: { 'PageContentItem_Video_Fragment': PageContentItem_Video_Fragment } }
      ) | null> } | null } | null };

export type SectionFragment = (
  { __typename?: 'Section', columns?: string | null, text?: (
    { __typename?: 'Text' }
    & { ' $fragmentRefs'?: { 'TextFragment': TextFragment } }
  ) | null, topButtonsCollection?: { __typename?: 'SectionTopButtonsCollection', total: number, items: Array<(
      { __typename?: 'Cta' }
      & { ' $fragmentRefs'?: { 'CtaFragment': CtaFragment } }
    ) | null> } | null, childrenCollection?: { __typename?: 'SectionChildrenCollection', total: number, items: Array<(
      { __typename?: 'Card' }
      & { ' $fragmentRefs'?: { 'CardFragment': CardFragment } }
    ) | (
      { __typename?: 'News' }
      & { ' $fragmentRefs'?: { 'NewsFragment': NewsFragment } }
    ) | null> } | null, bottomButtonsCollection?: { __typename?: 'SectionBottomButtonsCollection', total: number, items: Array<(
      { __typename?: 'Cta' }
      & { ' $fragmentRefs'?: { 'CtaFragment': CtaFragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'Sys_Section_Fragment': Sys_Section_Fragment } }
) & { ' $fragmentName'?: 'SectionFragment' };

export type StaticParamsQueryVariables = Exact<{
  skip?: Scalars['Int'];
  limit?: Scalars['Int'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type StaticParamsQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', total: number, items: Array<(
      { __typename?: 'Page' }
      & { ' $fragmentRefs'?: { 'PathSegmentFragment': PathSegmentFragment } }
    ) | null> } | null };

export type TimelineFragment = (
  { __typename?: 'Timeline', name?: string | null, title?: string | null, imagesCollection?: { __typename?: 'TimelineImagesCollection', total: number, items: Array<(
      { __typename?: 'GalleryItem' }
      & { ' $fragmentRefs'?: { 'GalleryItemFragment': GalleryItemFragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'Sys_Timeline_Fragment': Sys_Timeline_Fragment } }
) & { ' $fragmentName'?: 'TimelineFragment' };

type Sys_Card_Fragment = { __typename: 'Card', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Card_Fragment' };

type Sys_Carousel_Fragment = { __typename: 'Carousel', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Carousel_Fragment' };

type Sys_ContentTypeAsset_Fragment = { __typename: 'ContentTypeAsset', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_ContentTypeAsset_Fragment' };

type Sys_Cta_Fragment = { __typename: 'Cta', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Cta_Fragment' };

type Sys_Faq_Fragment = { __typename: 'Faq', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Faq_Fragment' };

type Sys_Footer_Fragment = { __typename: 'Footer', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Footer_Fragment' };

type Sys_FooterAddress_Fragment = { __typename: 'FooterAddress', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_FooterAddress_Fragment' };

type Sys_Gallery_Fragment = { __typename: 'Gallery', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Gallery_Fragment' };

type Sys_GalleryItem_Fragment = { __typename: 'GalleryItem', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_GalleryItem_Fragment' };

type Sys_Hero_Fragment = { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Hero_Fragment' };

type Sys_HeroSlide_Fragment = { __typename: 'HeroSlide', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_HeroSlide_Fragment' };

type Sys_Html_Fragment = { __typename: 'Html', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Html_Fragment' };

type Sys_List_Fragment = { __typename: 'List', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_List_Fragment' };

type Sys_Media_Fragment = { __typename: 'Media', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Media_Fragment' };

type Sys_MetaData_Fragment = { __typename: 'MetaData', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_MetaData_Fragment' };

type Sys_Navigation_Fragment = { __typename: 'Navigation', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Navigation_Fragment' };

type Sys_News_Fragment = { __typename: 'News', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_News_Fragment' };

type Sys_Office_Fragment = { __typename: 'Office', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Office_Fragment' };

type Sys_Page_Fragment = { __typename: 'Page', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Page_Fragment' };

type Sys_Section_Fragment = { __typename: 'Section', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Section_Fragment' };

type Sys_SeoSitemapRules_Fragment = { __typename: 'SeoSitemapRules', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_SeoSitemapRules_Fragment' };

type Sys_Text_Fragment = { __typename: 'Text', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Text_Fragment' };

type Sys_Timeline_Fragment = { __typename: 'Timeline', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Timeline_Fragment' };

type Sys_Url_Fragment = { __typename: 'Url', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Url_Fragment' };

type Sys_Video_Fragment = { __typename: 'Video', sys: { __typename?: 'Sys', id: string, publishedAt?: any | null } } & { ' $fragmentName'?: 'Sys_Video_Fragment' };

export type SysFragment = Sys_Card_Fragment | Sys_Carousel_Fragment | Sys_ContentTypeAsset_Fragment | Sys_Cta_Fragment | Sys_Faq_Fragment | Sys_Footer_Fragment | Sys_FooterAddress_Fragment | Sys_Gallery_Fragment | Sys_GalleryItem_Fragment | Sys_Hero_Fragment | Sys_HeroSlide_Fragment | Sys_Html_Fragment | Sys_List_Fragment | Sys_Media_Fragment | Sys_MetaData_Fragment | Sys_Navigation_Fragment | Sys_News_Fragment | Sys_Office_Fragment | Sys_Page_Fragment | Sys_Section_Fragment | Sys_SeoSitemapRules_Fragment | Sys_Text_Fragment | Sys_Timeline_Fragment | Sys_Url_Fragment | Sys_Video_Fragment;

export type AssetFragment = { __typename: 'Asset', title?: string | null, description?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'AssetFragment' };

type PageUrl_Card_Fragment = { __typename?: 'Card' } & { ' $fragmentName'?: 'PageUrl_Card_Fragment' };

type PageUrl_Carousel_Fragment = { __typename?: 'Carousel' } & { ' $fragmentName'?: 'PageUrl_Carousel_Fragment' };

type PageUrl_ContentTypeAsset_Fragment = { __typename?: 'ContentTypeAsset' } & { ' $fragmentName'?: 'PageUrl_ContentTypeAsset_Fragment' };

type PageUrl_Cta_Fragment = { __typename?: 'Cta' } & { ' $fragmentName'?: 'PageUrl_Cta_Fragment' };

type PageUrl_Faq_Fragment = { __typename?: 'Faq' } & { ' $fragmentName'?: 'PageUrl_Faq_Fragment' };

type PageUrl_Footer_Fragment = { __typename?: 'Footer' } & { ' $fragmentName'?: 'PageUrl_Footer_Fragment' };

type PageUrl_FooterAddress_Fragment = { __typename?: 'FooterAddress' } & { ' $fragmentName'?: 'PageUrl_FooterAddress_Fragment' };

type PageUrl_Gallery_Fragment = { __typename?: 'Gallery' } & { ' $fragmentName'?: 'PageUrl_Gallery_Fragment' };

type PageUrl_GalleryItem_Fragment = { __typename?: 'GalleryItem' } & { ' $fragmentName'?: 'PageUrl_GalleryItem_Fragment' };

type PageUrl_Hero_Fragment = { __typename?: 'Hero' } & { ' $fragmentName'?: 'PageUrl_Hero_Fragment' };

type PageUrl_HeroSlide_Fragment = { __typename?: 'HeroSlide' } & { ' $fragmentName'?: 'PageUrl_HeroSlide_Fragment' };

type PageUrl_Html_Fragment = { __typename?: 'Html' } & { ' $fragmentName'?: 'PageUrl_Html_Fragment' };

type PageUrl_List_Fragment = { __typename?: 'List' } & { ' $fragmentName'?: 'PageUrl_List_Fragment' };

type PageUrl_Media_Fragment = { __typename?: 'Media' } & { ' $fragmentName'?: 'PageUrl_Media_Fragment' };

type PageUrl_MetaData_Fragment = { __typename?: 'MetaData' } & { ' $fragmentName'?: 'PageUrl_MetaData_Fragment' };

type PageUrl_Navigation_Fragment = { __typename?: 'Navigation' } & { ' $fragmentName'?: 'PageUrl_Navigation_Fragment' };

type PageUrl_News_Fragment = { __typename?: 'News' } & { ' $fragmentName'?: 'PageUrl_News_Fragment' };

type PageUrl_Office_Fragment = { __typename?: 'Office' } & { ' $fragmentName'?: 'PageUrl_Office_Fragment' };

type PageUrl_Page_Fragment = { __typename?: 'Page' } & { ' $fragmentName'?: 'PageUrl_Page_Fragment' };

type PageUrl_Section_Fragment = { __typename?: 'Section' } & { ' $fragmentName'?: 'PageUrl_Section_Fragment' };

type PageUrl_SeoSitemapRules_Fragment = { __typename?: 'SeoSitemapRules' } & { ' $fragmentName'?: 'PageUrl_SeoSitemapRules_Fragment' };

type PageUrl_Text_Fragment = { __typename?: 'Text' } & { ' $fragmentName'?: 'PageUrl_Text_Fragment' };

type PageUrl_Timeline_Fragment = { __typename?: 'Timeline' } & { ' $fragmentName'?: 'PageUrl_Timeline_Fragment' };

type PageUrl_Url_Fragment = (
  { __typename?: 'Url' }
  & { ' $fragmentRefs'?: { 'UrlFragment': UrlFragment } }
) & { ' $fragmentName'?: 'PageUrl_Url_Fragment' };

type PageUrl_Video_Fragment = { __typename?: 'Video' } & { ' $fragmentName'?: 'PageUrl_Video_Fragment' };

export type PageUrlFragment = PageUrl_Card_Fragment | PageUrl_Carousel_Fragment | PageUrl_ContentTypeAsset_Fragment | PageUrl_Cta_Fragment | PageUrl_Faq_Fragment | PageUrl_Footer_Fragment | PageUrl_FooterAddress_Fragment | PageUrl_Gallery_Fragment | PageUrl_GalleryItem_Fragment | PageUrl_Hero_Fragment | PageUrl_HeroSlide_Fragment | PageUrl_Html_Fragment | PageUrl_List_Fragment | PageUrl_Media_Fragment | PageUrl_MetaData_Fragment | PageUrl_Navigation_Fragment | PageUrl_News_Fragment | PageUrl_Office_Fragment | PageUrl_Page_Fragment | PageUrl_Section_Fragment | PageUrl_SeoSitemapRules_Fragment | PageUrl_Text_Fragment | PageUrl_Timeline_Fragment | PageUrl_Url_Fragment | PageUrl_Video_Fragment;

export type TypeAssetFragment = { __typename?: 'ContentTypeAsset', imageUrl?: string | null, videoUrl?: string | null, sizes?: Array<string | null> | null, context?: Array<string | null> | null, autoplay?: boolean | null, controls?: boolean | null, loop?: boolean | null, muted?: boolean | null, videoResolution?: string | null, image?: (
    { __typename?: 'Asset' }
    & { ' $fragmentRefs'?: { 'AssetFragment': AssetFragment } }
  ) | null, video?: (
    { __typename?: 'Asset' }
    & { ' $fragmentRefs'?: { 'AssetFragment': AssetFragment } }
  ) | null } & { ' $fragmentName'?: 'TypeAssetFragment' };

export type TextFragment = (
  { __typename?: 'Text', name?: string | null, title?: string | null, subtitle?: string | null, caption?: string | null, description?: string | null, richText?: { __typename?: 'TextRichText', json: any } | null }
  & { ' $fragmentRefs'?: { 'Sys_Text_Fragment': Sys_Text_Fragment } }
) & { ' $fragmentName'?: 'TextFragment' };

export type PathSegmentFragment = (
  { __typename?: 'Page', name?: string | null, country?: Array<string | null> | null, language?: Array<string | null> | null, slug?: string | null, pageType?: string | null, path?: string | null }
  & { ' $fragmentRefs'?: { 'Sys_Page_Fragment': Sys_Page_Fragment } }
) & { ' $fragmentName'?: 'PathSegmentFragment' };

export type UrlFragment = (
  { __typename?: 'Url', name?: string | null, label?: string | null, externalLink?: string | null, linkType?: string | null, queryParameters?: string | null, contactFormRole?: string | null, internalLink?: (
    { __typename?: 'Page' }
    & { ' $fragmentRefs'?: { 'PathSegmentFragment': PathSegmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'Sys_Url_Fragment': Sys_Url_Fragment } }
) & { ' $fragmentName'?: 'UrlFragment' };

export type CtaFragment = (
  { __typename?: 'Cta', name?: string | null, template?: string | null, icon?: string | null, iconPosition?: string | null, newTab?: boolean | null, url?: (
    { __typename?: 'Url' }
    & { ' $fragmentRefs'?: { 'UrlFragment': UrlFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'Sys_Cta_Fragment': Sys_Cta_Fragment } }
) & { ' $fragmentName'?: 'CtaFragment' };

export type MediaFragment = (
  { __typename?: 'Media', name?: string | null, assetsCollection?: { __typename?: 'MediaAssetsCollection', total: number, items: Array<(
      { __typename?: 'ContentTypeAsset' }
      & { ' $fragmentRefs'?: { 'TypeAssetFragment': TypeAssetFragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'Sys_Media_Fragment': Sys_Media_Fragment } }
) & { ' $fragmentName'?: 'MediaFragment' };

export type VideoFragment = (
  { __typename?: 'Video', name?: string | null, title?: string | null, duration?: string | null, vimeoUrl?: string | null, autoplay?: boolean | null, controls?: boolean | null, loop?: boolean | null, muted?: boolean | null, type?: string | null, posterCollection?: { __typename?: 'VideoPosterCollection', total: number, items: Array<(
      { __typename?: 'ContentTypeAsset' }
      & { ' $fragmentRefs'?: { 'TypeAssetFragment': TypeAssetFragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'Sys_Video_Fragment': Sys_Video_Fragment } }
) & { ' $fragmentName'?: 'VideoFragment' };

export type GalleryItemFragment = (
  { __typename?: 'GalleryItem', name?: string | null, itemType?: string | null, assetsCollection?: { __typename?: 'GalleryItemAssetsCollection', total: number, items: Array<(
      { __typename?: 'ContentTypeAsset' }
      & { ' $fragmentRefs'?: { 'TypeAssetFragment': TypeAssetFragment } }
    ) | null> } | null, text?: (
    { __typename?: 'Text' }
    & { ' $fragmentRefs'?: { 'TextFragment': TextFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'Sys_GalleryItem_Fragment': Sys_GalleryItem_Fragment } }
) & { ' $fragmentName'?: 'GalleryItemFragment' };

export type OfficeFragment = (
  { __typename?: 'Office', name?: string | null, title?: string | null, streetAddressLine1?: string | null, streetAddressLine2?: string | null, addressLocality?: string | null, addressRegion?: string | null, postalCode?: string | null, addressCountry?: string | null, phone?: string | null, email?: string | null, ukCompanyNumber?: string | null, googleMapsLink?: string | null }
  & { ' $fragmentRefs'?: { 'Sys_Office_Fragment': Sys_Office_Fragment } }
) & { ' $fragmentName'?: 'OfficeFragment' };

export type NewsFragment = (
  { __typename?: 'News', date?: any | null, type?: string | null, title?: string | null, subtitle?: string | null, description?: string | null, assetOverlay?: string | null, organizationLogo?: (
    { __typename?: 'Asset' }
    & { ' $fragmentRefs'?: { 'AssetFragment': AssetFragment } }
  ) | null, url?: (
    { __typename?: 'Url' }
    & { ' $fragmentRefs'?: { 'UrlFragment': UrlFragment } }
  ) | null, assetsCollection?: { __typename?: 'NewsAssetsCollection', total: number, items: Array<(
      { __typename?: 'ContentTypeAsset' }
      & { ' $fragmentRefs'?: { 'TypeAssetFragment': TypeAssetFragment } }
    ) | null> } | null, linkedFrom?: { __typename?: 'NewsLinkingCollections', pageCollection?: { __typename?: 'PageCollection', total: number, items: Array<(
        { __typename?: 'Page' }
        & { ' $fragmentRefs'?: { 'PathSegmentFragment': PathSegmentFragment } }
      ) | null> } | null } | null }
  & { ' $fragmentRefs'?: { 'Sys_News_Fragment': Sys_News_Fragment } }
) & { ' $fragmentName'?: 'NewsFragment' };

export type NewsQueryQueryVariables = Exact<{
  skip?: Scalars['Int'];
  limit?: Scalars['Int'];
  preview?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
}>;


export type NewsQueryQuery = { __typename?: 'Query', newsCollection?: { __typename?: 'NewsCollection', total: number, skip: number, limit: number, items: Array<(
      { __typename?: 'News' }
      & { ' $fragmentRefs'?: { 'NewsFragment': NewsFragment } }
    ) | null> } | null };

type PageContentItem_Card_Fragment = (
  { __typename?: 'Card' }
  & { ' $fragmentRefs'?: { 'CardFragment': CardFragment } }
) & { ' $fragmentName'?: 'PageContentItem_Card_Fragment' };

type PageContentItem_Carousel_Fragment = (
  { __typename?: 'Carousel' }
  & { ' $fragmentRefs'?: { 'CarouselFragment': CarouselFragment } }
) & { ' $fragmentName'?: 'PageContentItem_Carousel_Fragment' };

type PageContentItem_Faq_Fragment = (
  { __typename?: 'Faq' }
  & { ' $fragmentRefs'?: { 'FaqFragment': FaqFragment } }
) & { ' $fragmentName'?: 'PageContentItem_Faq_Fragment' };

type PageContentItem_Footer_Fragment = { __typename?: 'Footer' } & { ' $fragmentName'?: 'PageContentItem_Footer_Fragment' };

type PageContentItem_Gallery_Fragment = (
  { __typename?: 'Gallery' }
  & { ' $fragmentRefs'?: { 'GalleryFragment': GalleryFragment } }
) & { ' $fragmentName'?: 'PageContentItem_Gallery_Fragment' };

type PageContentItem_Hero_Fragment = (
  { __typename?: 'Hero' }
  & { ' $fragmentRefs'?: { 'HeroFragment': HeroFragment } }
) & { ' $fragmentName'?: 'PageContentItem_Hero_Fragment' };

type PageContentItem_Html_Fragment = (
  { __typename?: 'Html' }
  & { ' $fragmentRefs'?: { 'HtmlFragment': HtmlFragment } }
) & { ' $fragmentName'?: 'PageContentItem_Html_Fragment' };

type PageContentItem_List_Fragment = (
  { __typename?: 'List' }
  & { ' $fragmentRefs'?: { 'ListFragment': ListFragment } }
) & { ' $fragmentName'?: 'PageContentItem_List_Fragment' };

type PageContentItem_Media_Fragment = (
  { __typename?: 'Media' }
  & { ' $fragmentRefs'?: { 'MediaFragment': MediaFragment } }
) & { ' $fragmentName'?: 'PageContentItem_Media_Fragment' };

type PageContentItem_Section_Fragment = (
  { __typename?: 'Section' }
  & { ' $fragmentRefs'?: { 'SectionFragment': SectionFragment } }
) & { ' $fragmentName'?: 'PageContentItem_Section_Fragment' };

type PageContentItem_Timeline_Fragment = (
  { __typename?: 'Timeline' }
  & { ' $fragmentRefs'?: { 'TimelineFragment': TimelineFragment } }
) & { ' $fragmentName'?: 'PageContentItem_Timeline_Fragment' };

type PageContentItem_Video_Fragment = (
  { __typename?: 'Video' }
  & { ' $fragmentRefs'?: { 'VideoFragment': VideoFragment } }
) & { ' $fragmentName'?: 'PageContentItem_Video_Fragment' };

export type PageContentItemFragment = PageContentItem_Card_Fragment | PageContentItem_Carousel_Fragment | PageContentItem_Faq_Fragment | PageContentItem_Footer_Fragment | PageContentItem_Gallery_Fragment | PageContentItem_Hero_Fragment | PageContentItem_Html_Fragment | PageContentItem_List_Fragment | PageContentItem_Media_Fragment | PageContentItem_Section_Fragment | PageContentItem_Timeline_Fragment | PageContentItem_Video_Fragment;

type NewsArticleRichTextEntry_Card_Fragment = (
  { __typename?: 'Card' }
  & { ' $fragmentRefs'?: { 'Sys_Card_Fragment': Sys_Card_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Card_Fragment' };

type NewsArticleRichTextEntry_Carousel_Fragment = (
  { __typename?: 'Carousel' }
  & { ' $fragmentRefs'?: { 'Sys_Carousel_Fragment': Sys_Carousel_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Carousel_Fragment' };

type NewsArticleRichTextEntry_ContentTypeAsset_Fragment = (
  { __typename?: 'ContentTypeAsset' }
  & { ' $fragmentRefs'?: { 'Sys_ContentTypeAsset_Fragment': Sys_ContentTypeAsset_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_ContentTypeAsset_Fragment' };

type NewsArticleRichTextEntry_Cta_Fragment = (
  { __typename?: 'Cta' }
  & { ' $fragmentRefs'?: { 'Sys_Cta_Fragment': Sys_Cta_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Cta_Fragment' };

type NewsArticleRichTextEntry_Faq_Fragment = (
  { __typename?: 'Faq' }
  & { ' $fragmentRefs'?: { 'Sys_Faq_Fragment': Sys_Faq_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Faq_Fragment' };

type NewsArticleRichTextEntry_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { ' $fragmentRefs'?: { 'Sys_Footer_Fragment': Sys_Footer_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Footer_Fragment' };

type NewsArticleRichTextEntry_FooterAddress_Fragment = (
  { __typename?: 'FooterAddress' }
  & { ' $fragmentRefs'?: { 'Sys_FooterAddress_Fragment': Sys_FooterAddress_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_FooterAddress_Fragment' };

type NewsArticleRichTextEntry_Gallery_Fragment = (
  { __typename?: 'Gallery' }
  & { ' $fragmentRefs'?: { 'Sys_Gallery_Fragment': Sys_Gallery_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Gallery_Fragment' };

type NewsArticleRichTextEntry_GalleryItem_Fragment = (
  { __typename?: 'GalleryItem' }
  & { ' $fragmentRefs'?: { 'Sys_GalleryItem_Fragment': Sys_GalleryItem_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_GalleryItem_Fragment' };

type NewsArticleRichTextEntry_Hero_Fragment = (
  { __typename?: 'Hero' }
  & { ' $fragmentRefs'?: { 'Sys_Hero_Fragment': Sys_Hero_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Hero_Fragment' };

type NewsArticleRichTextEntry_HeroSlide_Fragment = (
  { __typename?: 'HeroSlide' }
  & { ' $fragmentRefs'?: { 'Sys_HeroSlide_Fragment': Sys_HeroSlide_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_HeroSlide_Fragment' };

type NewsArticleRichTextEntry_Html_Fragment = (
  { __typename?: 'Html' }
  & { ' $fragmentRefs'?: { 'Sys_Html_Fragment': Sys_Html_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Html_Fragment' };

type NewsArticleRichTextEntry_List_Fragment = (
  { __typename?: 'List' }
  & { ' $fragmentRefs'?: { 'Sys_List_Fragment': Sys_List_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_List_Fragment' };

type NewsArticleRichTextEntry_Media_Fragment = (
  { __typename?: 'Media' }
  & { ' $fragmentRefs'?: { 'Sys_Media_Fragment': Sys_Media_Fragment;'MediaFragment': MediaFragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Media_Fragment' };

type NewsArticleRichTextEntry_MetaData_Fragment = (
  { __typename?: 'MetaData' }
  & { ' $fragmentRefs'?: { 'Sys_MetaData_Fragment': Sys_MetaData_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_MetaData_Fragment' };

type NewsArticleRichTextEntry_Navigation_Fragment = (
  { __typename?: 'Navigation' }
  & { ' $fragmentRefs'?: { 'Sys_Navigation_Fragment': Sys_Navigation_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Navigation_Fragment' };

type NewsArticleRichTextEntry_News_Fragment = (
  { __typename?: 'News' }
  & { ' $fragmentRefs'?: { 'Sys_News_Fragment': Sys_News_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_News_Fragment' };

type NewsArticleRichTextEntry_Office_Fragment = (
  { __typename?: 'Office' }
  & { ' $fragmentRefs'?: { 'Sys_Office_Fragment': Sys_Office_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Office_Fragment' };

type NewsArticleRichTextEntry_Page_Fragment = (
  { __typename?: 'Page' }
  & { ' $fragmentRefs'?: { 'Sys_Page_Fragment': Sys_Page_Fragment;'PathSegmentFragment': PathSegmentFragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Page_Fragment' };

type NewsArticleRichTextEntry_Section_Fragment = (
  { __typename?: 'Section' }
  & { ' $fragmentRefs'?: { 'Sys_Section_Fragment': Sys_Section_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Section_Fragment' };

type NewsArticleRichTextEntry_SeoSitemapRules_Fragment = (
  { __typename?: 'SeoSitemapRules' }
  & { ' $fragmentRefs'?: { 'Sys_SeoSitemapRules_Fragment': Sys_SeoSitemapRules_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_SeoSitemapRules_Fragment' };

type NewsArticleRichTextEntry_Text_Fragment = (
  { __typename?: 'Text' }
  & { ' $fragmentRefs'?: { 'Sys_Text_Fragment': Sys_Text_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Text_Fragment' };

type NewsArticleRichTextEntry_Timeline_Fragment = (
  { __typename?: 'Timeline' }
  & { ' $fragmentRefs'?: { 'Sys_Timeline_Fragment': Sys_Timeline_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Timeline_Fragment' };

type NewsArticleRichTextEntry_Url_Fragment = (
  { __typename?: 'Url' }
  & { ' $fragmentRefs'?: { 'Sys_Url_Fragment': Sys_Url_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Url_Fragment' };

type NewsArticleRichTextEntry_Video_Fragment = (
  { __typename?: 'Video' }
  & { ' $fragmentRefs'?: { 'Sys_Video_Fragment': Sys_Video_Fragment } }
) & { ' $fragmentName'?: 'NewsArticleRichTextEntry_Video_Fragment' };

export type NewsArticleRichTextEntryFragment = NewsArticleRichTextEntry_Card_Fragment | NewsArticleRichTextEntry_Carousel_Fragment | NewsArticleRichTextEntry_ContentTypeAsset_Fragment | NewsArticleRichTextEntry_Cta_Fragment | NewsArticleRichTextEntry_Faq_Fragment | NewsArticleRichTextEntry_Footer_Fragment | NewsArticleRichTextEntry_FooterAddress_Fragment | NewsArticleRichTextEntry_Gallery_Fragment | NewsArticleRichTextEntry_GalleryItem_Fragment | NewsArticleRichTextEntry_Hero_Fragment | NewsArticleRichTextEntry_HeroSlide_Fragment | NewsArticleRichTextEntry_Html_Fragment | NewsArticleRichTextEntry_List_Fragment | NewsArticleRichTextEntry_Media_Fragment | NewsArticleRichTextEntry_MetaData_Fragment | NewsArticleRichTextEntry_Navigation_Fragment | NewsArticleRichTextEntry_News_Fragment | NewsArticleRichTextEntry_Office_Fragment | NewsArticleRichTextEntry_Page_Fragment | NewsArticleRichTextEntry_Section_Fragment | NewsArticleRichTextEntry_SeoSitemapRules_Fragment | NewsArticleRichTextEntry_Text_Fragment | NewsArticleRichTextEntry_Timeline_Fragment | NewsArticleRichTextEntry_Url_Fragment | NewsArticleRichTextEntry_Video_Fragment;

export type NewsArticleRichTextLinksFragment = { __typename?: 'NewsArticleLinks', assets: { __typename?: 'NewsArticleAssets', hyperlink: Array<(
      { __typename?: 'Asset' }
      & { ' $fragmentRefs'?: { 'AssetFragment': AssetFragment } }
    ) | null>, block: Array<(
      { __typename?: 'Asset' }
      & { ' $fragmentRefs'?: { 'AssetFragment': AssetFragment } }
    ) | null> }, entries: { __typename?: 'NewsArticleEntries', inline: Array<(
      { __typename?: 'Card' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Card_Fragment': NewsArticleRichTextEntry_Card_Fragment } }
    ) | (
      { __typename?: 'Carousel' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Carousel_Fragment': NewsArticleRichTextEntry_Carousel_Fragment } }
    ) | (
      { __typename?: 'ContentTypeAsset' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_ContentTypeAsset_Fragment': NewsArticleRichTextEntry_ContentTypeAsset_Fragment } }
    ) | (
      { __typename?: 'Cta' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Cta_Fragment': NewsArticleRichTextEntry_Cta_Fragment } }
    ) | (
      { __typename?: 'Faq' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Faq_Fragment': NewsArticleRichTextEntry_Faq_Fragment } }
    ) | (
      { __typename?: 'Footer' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Footer_Fragment': NewsArticleRichTextEntry_Footer_Fragment } }
    ) | (
      { __typename?: 'FooterAddress' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_FooterAddress_Fragment': NewsArticleRichTextEntry_FooterAddress_Fragment } }
    ) | (
      { __typename?: 'Gallery' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Gallery_Fragment': NewsArticleRichTextEntry_Gallery_Fragment } }
    ) | (
      { __typename?: 'GalleryItem' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_GalleryItem_Fragment': NewsArticleRichTextEntry_GalleryItem_Fragment } }
    ) | (
      { __typename?: 'Hero' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Hero_Fragment': NewsArticleRichTextEntry_Hero_Fragment } }
    ) | (
      { __typename?: 'HeroSlide' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_HeroSlide_Fragment': NewsArticleRichTextEntry_HeroSlide_Fragment } }
    ) | (
      { __typename?: 'Html' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Html_Fragment': NewsArticleRichTextEntry_Html_Fragment } }
    ) | (
      { __typename?: 'List' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_List_Fragment': NewsArticleRichTextEntry_List_Fragment } }
    ) | (
      { __typename?: 'Media' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Media_Fragment': NewsArticleRichTextEntry_Media_Fragment } }
    ) | (
      { __typename?: 'MetaData' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_MetaData_Fragment': NewsArticleRichTextEntry_MetaData_Fragment } }
    ) | (
      { __typename?: 'Navigation' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Navigation_Fragment': NewsArticleRichTextEntry_Navigation_Fragment } }
    ) | (
      { __typename?: 'News' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_News_Fragment': NewsArticleRichTextEntry_News_Fragment } }
    ) | (
      { __typename?: 'Office' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Office_Fragment': NewsArticleRichTextEntry_Office_Fragment } }
    ) | (
      { __typename?: 'Page' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Page_Fragment': NewsArticleRichTextEntry_Page_Fragment } }
    ) | (
      { __typename?: 'Section' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Section_Fragment': NewsArticleRichTextEntry_Section_Fragment } }
    ) | (
      { __typename?: 'SeoSitemapRules' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_SeoSitemapRules_Fragment': NewsArticleRichTextEntry_SeoSitemapRules_Fragment } }
    ) | (
      { __typename?: 'Text' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Text_Fragment': NewsArticleRichTextEntry_Text_Fragment } }
    ) | (
      { __typename?: 'Timeline' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Timeline_Fragment': NewsArticleRichTextEntry_Timeline_Fragment } }
    ) | (
      { __typename?: 'Url' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Url_Fragment': NewsArticleRichTextEntry_Url_Fragment } }
    ) | (
      { __typename?: 'Video' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Video_Fragment': NewsArticleRichTextEntry_Video_Fragment } }
    ) | null>, hyperlink: Array<(
      { __typename?: 'Card' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Card_Fragment': NewsArticleRichTextEntry_Card_Fragment } }
    ) | (
      { __typename?: 'Carousel' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Carousel_Fragment': NewsArticleRichTextEntry_Carousel_Fragment } }
    ) | (
      { __typename?: 'ContentTypeAsset' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_ContentTypeAsset_Fragment': NewsArticleRichTextEntry_ContentTypeAsset_Fragment } }
    ) | (
      { __typename?: 'Cta' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Cta_Fragment': NewsArticleRichTextEntry_Cta_Fragment } }
    ) | (
      { __typename?: 'Faq' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Faq_Fragment': NewsArticleRichTextEntry_Faq_Fragment } }
    ) | (
      { __typename?: 'Footer' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Footer_Fragment': NewsArticleRichTextEntry_Footer_Fragment } }
    ) | (
      { __typename?: 'FooterAddress' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_FooterAddress_Fragment': NewsArticleRichTextEntry_FooterAddress_Fragment } }
    ) | (
      { __typename?: 'Gallery' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Gallery_Fragment': NewsArticleRichTextEntry_Gallery_Fragment } }
    ) | (
      { __typename?: 'GalleryItem' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_GalleryItem_Fragment': NewsArticleRichTextEntry_GalleryItem_Fragment } }
    ) | (
      { __typename?: 'Hero' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Hero_Fragment': NewsArticleRichTextEntry_Hero_Fragment } }
    ) | (
      { __typename?: 'HeroSlide' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_HeroSlide_Fragment': NewsArticleRichTextEntry_HeroSlide_Fragment } }
    ) | (
      { __typename?: 'Html' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Html_Fragment': NewsArticleRichTextEntry_Html_Fragment } }
    ) | (
      { __typename?: 'List' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_List_Fragment': NewsArticleRichTextEntry_List_Fragment } }
    ) | (
      { __typename?: 'Media' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Media_Fragment': NewsArticleRichTextEntry_Media_Fragment } }
    ) | (
      { __typename?: 'MetaData' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_MetaData_Fragment': NewsArticleRichTextEntry_MetaData_Fragment } }
    ) | (
      { __typename?: 'Navigation' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Navigation_Fragment': NewsArticleRichTextEntry_Navigation_Fragment } }
    ) | (
      { __typename?: 'News' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_News_Fragment': NewsArticleRichTextEntry_News_Fragment } }
    ) | (
      { __typename?: 'Office' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Office_Fragment': NewsArticleRichTextEntry_Office_Fragment } }
    ) | (
      { __typename?: 'Page' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Page_Fragment': NewsArticleRichTextEntry_Page_Fragment } }
    ) | (
      { __typename?: 'Section' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Section_Fragment': NewsArticleRichTextEntry_Section_Fragment } }
    ) | (
      { __typename?: 'SeoSitemapRules' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_SeoSitemapRules_Fragment': NewsArticleRichTextEntry_SeoSitemapRules_Fragment } }
    ) | (
      { __typename?: 'Text' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Text_Fragment': NewsArticleRichTextEntry_Text_Fragment } }
    ) | (
      { __typename?: 'Timeline' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Timeline_Fragment': NewsArticleRichTextEntry_Timeline_Fragment } }
    ) | (
      { __typename?: 'Url' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Url_Fragment': NewsArticleRichTextEntry_Url_Fragment } }
    ) | (
      { __typename?: 'Video' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Video_Fragment': NewsArticleRichTextEntry_Video_Fragment } }
    ) | null>, block: Array<(
      { __typename?: 'Card' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Card_Fragment': NewsArticleRichTextEntry_Card_Fragment } }
    ) | (
      { __typename?: 'Carousel' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Carousel_Fragment': NewsArticleRichTextEntry_Carousel_Fragment } }
    ) | (
      { __typename?: 'ContentTypeAsset' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_ContentTypeAsset_Fragment': NewsArticleRichTextEntry_ContentTypeAsset_Fragment } }
    ) | (
      { __typename?: 'Cta' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Cta_Fragment': NewsArticleRichTextEntry_Cta_Fragment } }
    ) | (
      { __typename?: 'Faq' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Faq_Fragment': NewsArticleRichTextEntry_Faq_Fragment } }
    ) | (
      { __typename?: 'Footer' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Footer_Fragment': NewsArticleRichTextEntry_Footer_Fragment } }
    ) | (
      { __typename?: 'FooterAddress' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_FooterAddress_Fragment': NewsArticleRichTextEntry_FooterAddress_Fragment } }
    ) | (
      { __typename?: 'Gallery' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Gallery_Fragment': NewsArticleRichTextEntry_Gallery_Fragment } }
    ) | (
      { __typename?: 'GalleryItem' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_GalleryItem_Fragment': NewsArticleRichTextEntry_GalleryItem_Fragment } }
    ) | (
      { __typename?: 'Hero' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Hero_Fragment': NewsArticleRichTextEntry_Hero_Fragment } }
    ) | (
      { __typename?: 'HeroSlide' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_HeroSlide_Fragment': NewsArticleRichTextEntry_HeroSlide_Fragment } }
    ) | (
      { __typename?: 'Html' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Html_Fragment': NewsArticleRichTextEntry_Html_Fragment } }
    ) | (
      { __typename?: 'List' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_List_Fragment': NewsArticleRichTextEntry_List_Fragment } }
    ) | (
      { __typename?: 'Media' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Media_Fragment': NewsArticleRichTextEntry_Media_Fragment } }
    ) | (
      { __typename?: 'MetaData' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_MetaData_Fragment': NewsArticleRichTextEntry_MetaData_Fragment } }
    ) | (
      { __typename?: 'Navigation' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Navigation_Fragment': NewsArticleRichTextEntry_Navigation_Fragment } }
    ) | (
      { __typename?: 'News' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_News_Fragment': NewsArticleRichTextEntry_News_Fragment } }
    ) | (
      { __typename?: 'Office' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Office_Fragment': NewsArticleRichTextEntry_Office_Fragment } }
    ) | (
      { __typename?: 'Page' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Page_Fragment': NewsArticleRichTextEntry_Page_Fragment } }
    ) | (
      { __typename?: 'Section' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Section_Fragment': NewsArticleRichTextEntry_Section_Fragment } }
    ) | (
      { __typename?: 'SeoSitemapRules' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_SeoSitemapRules_Fragment': NewsArticleRichTextEntry_SeoSitemapRules_Fragment } }
    ) | (
      { __typename?: 'Text' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Text_Fragment': NewsArticleRichTextEntry_Text_Fragment } }
    ) | (
      { __typename?: 'Timeline' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Timeline_Fragment': NewsArticleRichTextEntry_Timeline_Fragment } }
    ) | (
      { __typename?: 'Url' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Url_Fragment': NewsArticleRichTextEntry_Url_Fragment } }
    ) | (
      { __typename?: 'Video' }
      & { ' $fragmentRefs'?: { 'NewsArticleRichTextEntry_Video_Fragment': NewsArticleRichTextEntry_Video_Fragment } }
    ) | null> } } & { ' $fragmentName'?: 'NewsArticleRichTextLinksFragment' };

export type NewsArticleRichTextFragment = { __typename?: 'NewsArticle', json: any, links: (
    { __typename?: 'NewsArticleLinks' }
    & { ' $fragmentRefs'?: { 'NewsArticleRichTextLinksFragment': NewsArticleRichTextLinksFragment } }
  ) } & { ' $fragmentName'?: 'NewsArticleRichTextFragment' };

export type MetaDataFragment = (
  { __typename?: 'MetaData', title?: string | null, description?: string | null, context?: Array<string | null> | null, assetsCollection?: { __typename?: 'MetaDataAssetsCollection', total: number, items: Array<(
      { __typename?: 'ContentTypeAsset' }
      & { ' $fragmentRefs'?: { 'TypeAssetFragment': TypeAssetFragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'Sys_MetaData_Fragment': Sys_MetaData_Fragment } }
) & { ' $fragmentName'?: 'MetaDataFragment' };

export type SeoFragment = (
  { __typename?: 'SeoSitemapRules', name?: string | null, robotsNoFollow?: boolean | null, robotsNoIndex?: boolean | null, indexFrequency?: string | null, priority?: string | null }
  & { ' $fragmentRefs'?: { 'Sys_SeoSitemapRules_Fragment': Sys_SeoSitemapRules_Fragment } }
) & { ' $fragmentName'?: 'SeoFragment' };

export type NewsPageQueryQueryVariables = Exact<{
  language?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type NewsPageQueryQuery = { __typename?: 'Query', page?: { __typename?: 'Page', parentPage?: (
      { __typename?: 'Page' }
      & { ' $fragmentRefs'?: { 'PathSegmentFragment': PathSegmentFragment } }
    ) | null, structuredDataCollection?: { __typename?: 'PageStructuredDataCollection', total: number, items: Array<(
        { __typename?: 'News' }
        & { ' $fragmentRefs'?: { 'NewsFragment': NewsFragment } }
      ) | null> } | null } | null };

export const SysFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"sys"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<SysFragment, unknown>;
export const OfficeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"office"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Office"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"streetAddressLine1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"streetAddressLine2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"addressLocality"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"postalCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"addressCountry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"ukCompanyNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"googleMapsLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}]}}]} as unknown as DocumentNode<OfficeFragment, unknown>;
export const FooterAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"footerAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FooterAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"addressFormat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"office"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"office"}}]}}]}}]} as unknown as DocumentNode<FooterAddressFragment, unknown>;
export const PathSegmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pathSegment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Page"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"pageType"}},{"kind":"Field","alias":{"kind":"Name","value":"path"},"name":{"kind":"Name","value":"slug"}}]}}]} as unknown as DocumentNode<PathSegmentFragment, unknown>;
export const UrlFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"url"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Url"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pathSegment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"linkType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"queryParameters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"contactFormRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}]}}]} as unknown as DocumentNode<UrlFragment, unknown>;
export const PageUrlFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageUrl"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Url"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<PageUrlFragment, unknown>;
export const AssetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<AssetFragment, unknown>;
export const TypeAssetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"typeAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentTypeAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"video"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"sizes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"context"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"autoplay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"controls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"loop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"muted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"videoResolution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}]}}]} as unknown as DocumentNode<TypeAssetFragment, unknown>;
export const TextFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"text"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Text"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"caption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"richText"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]} as unknown as DocumentNode<TextFragment, unknown>;
export const CtaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"cta"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cta"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"iconPosition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"newTab"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}]}}]} as unknown as DocumentNode<CtaFragment, unknown>;
export const HeroSlideFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"heroSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"slideType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"overlayCtaLabel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"overlayAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"slideAppearance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"assetsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"typeAsset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"slideTextCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"3"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"overlayText"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"overlayButtonsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"cta"}}]}}]}}]}}]} as unknown as DocumentNode<HeroSlideFragment, unknown>;
export const HeroFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"hero"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hero"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"heroType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"scrollCtaLabel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"slidesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"heroSlide"}}]}}]}}]}}]} as unknown as DocumentNode<HeroFragment, unknown>;
export const ListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"list"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"List"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<ListFragment, unknown>;
export const CardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"card"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Card"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"contentLayout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"cardLayout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"cardAspectRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"margins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"contentSize"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"widthLimit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"cta"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"6"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"typeAsset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"typeAsset"}}]}}]}}]} as unknown as DocumentNode<CardFragment, unknown>;
export const CarouselFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"carousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Carousel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"speed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"slidesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"card"}}]}}]}}]}}]} as unknown as DocumentNode<CarouselFragment, unknown>;
export const GalleryItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"galleryItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GalleryItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"itemType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"assetsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"typeAsset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<GalleryItemFragment, unknown>;
export const GalleryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"gallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Gallery"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"speed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"galleryItem"}}]}}]}}]}}]} as unknown as DocumentNode<GalleryFragment, unknown>;
export const TimelineFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"timeline"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Timeline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"galleryItem"}}]}}]}}]}}]} as unknown as DocumentNode<TimelineFragment, unknown>;
export const MediaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"media"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Media"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"assetsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"4"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"typeAsset"}}]}}]}}]}}]} as unknown as DocumentNode<MediaFragment, unknown>;
export const VideoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"video"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"vimeoUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"autoplay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"controls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"loop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"muted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"posterCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"3"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"typeAsset"}}]}}]}}]}}]} as unknown as DocumentNode<VideoFragment, unknown>;
export const NewsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"news"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"News"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"assetOverlay"}},{"kind":"Field","name":{"kind":"Name","value":"organizationLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"4"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"typeAsset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedFrom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"allowedLocales"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"language"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pathSegment"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewsFragment, unknown>;
export const SectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"section"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Section"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"columns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topButtonsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"cta"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"childrenCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"6"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"card"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"news"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bottomButtonsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"cta"}}]}}]}}]}}]} as unknown as DocumentNode<SectionFragment, unknown>;
export const FaqFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"faq"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"questionsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<FaqFragment, unknown>;
export const HtmlFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"html"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Html"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"html"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}]}}]} as unknown as DocumentNode<HtmlFragment, unknown>;
export const PageContentItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageContentItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageContentItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"hero"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"list"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"card"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"carousel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"gallery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"timeline"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"media"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"video"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"section"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"faq"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"html"}}]}}]} as unknown as DocumentNode<PageContentItemFragment, unknown>;
export const NewsArticleRichTextEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"newsArticleRichTextEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"pathSegment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"media"}}]}}]} as unknown as DocumentNode<NewsArticleRichTextEntryFragment, unknown>;
export const NewsArticleRichTextLinksFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"newsArticleRichTextLinks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsArticleLinks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hyperlink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"newsArticleRichTextEntry"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hyperlink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"newsArticleRichTextEntry"}}]}},{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"newsArticleRichTextEntry"}}]}}]}}]}}]} as unknown as DocumentNode<NewsArticleRichTextLinksFragment, unknown>;
export const NewsArticleRichTextFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"newsArticleRichText"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"newsArticleRichTextLinks"}}]}}]}}]} as unknown as DocumentNode<NewsArticleRichTextFragment, unknown>;
export const MetaDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"metaData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetaData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"assetsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"3"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"typeAsset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}]}}]} as unknown as DocumentNode<MetaDataFragment, unknown>;
export const SeoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"seo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SeoSitemapRules"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"robotsNoFollow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"robotsNoIndex"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"indexFrequency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"priority"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}]}}]} as unknown as DocumentNode<SeoFragment, unknown>;
export const FooterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Footer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"footerCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryLinksCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryLinksCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"footerAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"facebookUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"instagramUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"linkedInUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"twitterUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}]}}]}}]}},...SysFragmentDoc.definitions,...TextFragmentDoc.definitions,...PageUrlFragmentDoc.definitions,...UrlFragmentDoc.definitions,...PathSegmentFragmentDoc.definitions,...FooterAddressFragmentDoc.definitions,...OfficeFragmentDoc.definitions]} as unknown as DocumentNode<FooterQuery, FooterQueryVariables>;
export const PageMetaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageMeta"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pathSegment"}},{"kind":"Field","name":{"kind":"Name","value":"robots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"seo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metaDataCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"metaData"}}]}}]}}]}}]}},...PathSegmentFragmentDoc.definitions,...SysFragmentDoc.definitions,...SeoFragmentDoc.definitions,...MetaDataFragmentDoc.definitions,...TypeAssetFragmentDoc.definitions,...AssetFragmentDoc.definitions]} as unknown as DocumentNode<PageMetaQuery, PageMetaQueryVariables>;
export const PageMetaGlobalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageMetaGlobal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metaDataCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"metaData"}}]}}]}}]}},...MetaDataFragmentDoc.definitions,...SysFragmentDoc.definitions,...TypeAssetFragmentDoc.definitions,...AssetFragmentDoc.definitions]} as unknown as DocumentNode<PageMetaGlobalQuery, PageMetaGlobalQueryVariables>;
export const NavigationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Navigation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sys"}},{"kind":"Field","name":{"kind":"Name","value":"primaryLinksCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryLinksCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"facebookUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"instagramUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"linkedInUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"Field","name":{"kind":"Name","value":"twitterUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}]}}]}}]}},...SysFragmentDoc.definitions,...PageUrlFragmentDoc.definitions,...UrlFragmentDoc.definitions,...PathSegmentFragmentDoc.definitions]} as unknown as DocumentNode<NavigationQuery, NavigationQueryVariables>;
export const NextPrevNewsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NextPrevNewsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"prevNewsItem"},"name":{"kind":"Name","value":"newsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"news","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"date_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"news"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nextNewsItem"},"name":{"kind":"Name","value":"newsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"news","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"date_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"news"}}]}}]}}]}},...NewsFragmentDoc.definitions,...SysFragmentDoc.definitions,...AssetFragmentDoc.definitions,...UrlFragmentDoc.definitions,...PathSegmentFragmentDoc.definitions,...TypeAssetFragmentDoc.definitions]} as unknown as DocumentNode<NextPrevNewsQueryQuery, NextPrevNewsQueryQueryVariables>;
export const NewsArticlePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsArticlePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sys"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"newsArticleRichText"}}]}}]}}]}}]}},...NewsArticleRichTextFragmentDoc.definitions,...NewsArticleRichTextLinksFragmentDoc.definitions,...AssetFragmentDoc.definitions,...NewsArticleRichTextEntryFragmentDoc.definitions,...SysFragmentDoc.definitions,...PathSegmentFragmentDoc.definitions,...MediaFragmentDoc.definitions,...TypeAssetFragmentDoc.definitions]} as unknown as DocumentNode<NewsArticlePageQueryQuery, NewsArticlePageQueryQueryVariables>;
export const PageRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pathSegment"}}]}}]}},...PathSegmentFragmentDoc.definitions,...SysFragmentDoc.definitions]} as unknown as DocumentNode<PageRecordQuery, PageRecordQueryVariables>;
export const PageRecordContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageRecordContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageContentItem"}}]}}]}}]}}]}},...PageContentItemFragmentDoc.definitions,...HeroFragmentDoc.definitions,...SysFragmentDoc.definitions,...HeroSlideFragmentDoc.definitions,...TypeAssetFragmentDoc.definitions,...AssetFragmentDoc.definitions,...TextFragmentDoc.definitions,...CtaFragmentDoc.definitions,...UrlFragmentDoc.definitions,...PathSegmentFragmentDoc.definitions,...ListFragmentDoc.definitions,...CardFragmentDoc.definitions,...CarouselFragmentDoc.definitions,...GalleryFragmentDoc.definitions,...GalleryItemFragmentDoc.definitions,...TimelineFragmentDoc.definitions,...MediaFragmentDoc.definitions,...VideoFragmentDoc.definitions,...SectionFragmentDoc.definitions,...NewsFragmentDoc.definitions,...FaqFragmentDoc.definitions,...HtmlFragmentDoc.definitions]} as unknown as DocumentNode<PageRecordContentQuery, PageRecordContentQueryVariables>;
export const StaticParamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StaticParams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pathSegment"}}]}}]}}]}},...PathSegmentFragmentDoc.definitions,...SysFragmentDoc.definitions]} as unknown as DocumentNode<StaticParamsQuery, StaticParamsQueryVariables>;
export const NewsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"newsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"date_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"news"}}]}}]}}]}},...NewsFragmentDoc.definitions,...SysFragmentDoc.definitions,...AssetFragmentDoc.definitions,...UrlFragmentDoc.definitions,...PathSegmentFragmentDoc.definitions,...TypeAssetFragmentDoc.definitions]} as unknown as DocumentNode<NewsQueryQuery, NewsQueryQueryVariables>;
export const NewsPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pathSegment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"structuredDataCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"news"}}]}}]}}]}}]}},...PathSegmentFragmentDoc.definitions,...SysFragmentDoc.definitions,...NewsFragmentDoc.definitions,...AssetFragmentDoc.definitions,...UrlFragmentDoc.definitions,...TypeAssetFragmentDoc.definitions]} as unknown as DocumentNode<NewsPageQueryQuery, NewsPageQueryQueryVariables>;